(function () {
  'use strict';

  var root = document.querySelector('[data-wf-showroom]');
  if (!root) return;

  document.documentElement.classList.add('wf-showroom-page');

  var LAST_VEHICLE_KEY = 'wf-sr-last-vehicle';
  var ALLOWED_TYPES = {
    brakes: true,
    'center caps': true,
    cooling: true,
    drivetrain: true,
    'engine components': true,
    'exhaust systems': true,
    'exterior styling': true,
    interior: true,
    'lug nuts': true,
    'rim shells': true,
    suspension: true,
    'wheel accessories': true,
    'wheel hardware': true,
    'wheel pair': true,
    'wheel set': true,
    'wheel single': true
  };
  var CATEGORY_SORT = [
    'wheel set',
    'wheel pair',
    'wheel single',
    'rim shells',
    'wheel accessories',
    'wheel hardware',
    'center caps',
    'lug nuts',
    'brakes',
    'cooling',
    'drivetrain',
    'engine components',
    'exhaust systems',
    'exterior styling',
    'interior',
    'suspension'
  ];
  var WHEELS_INVENTORY_HANDLE = 'wheel-inventory';
  var SUSPENSION_KITS_HANDLE = 'wheelflip-suspension-kits';
  var SUSPENSION_KITS_COLLECTION_IDS = {
    '159056986399': true,
    '520031109407': true
  };
  var ORIENTATION_SORT = ['Full Set', 'Front Pair', 'Rear Pair'];
  var ORIENTATION_HINTS = {
    'full set': ['Full Set'],
    fullset: ['Full Set'],
    full: ['Full Set'],
    set: ['Full Set'],
    'front pair': ['Front Pair'],
    frontpair: ['Front Pair'],
    front: ['Front Pair'],
    fronts: ['Front Pair'],
    'rear pair': ['Rear Pair'],
    rearpair: ['Rear Pair'],
    rear: ['Rear Pair'],
    rears: ['Rear Pair']
  };
  var UNIVERSAL_YMM_TAG = 'YMM_UNIVERSAL';
  var CATALOG_PAGE_SIZE = 250;
  var MAX_CATALOG_PAGES = 400;
  var GRID_PAGE_SIZE = 60;
  var GRID_LOAD_MORE = 20;
  var SEARCH_TYPE_PILL_MAX = 10;
  var SEARCH_STOP = {
    a: 1, an: 1, and: 1, at: 1, by: 1, for: 1, from: 1, in: 1, into: 1,
    is: 1, it: 1, my: 1, of: 1, on: 1, or: 1, our: 1, part: 1, parts: 1,
    product: 1, products: 1, the: 1, this: 1, that: 1, to: 1, with: 1, your: 1,
    kit: 1, kits: 1
  };
  var SEARCH_SYNONYMS = {
    wheel: ['wheels', 'rim', 'rims'],
    wheels: ['wheel', 'rim', 'rims'],
    rim: ['rims', 'wheel', 'wheels'],
    rims: ['rim', 'wheel', 'wheels'],
    lug: ['lugs', 'lug nuts'],
    lugs: ['lug', 'lug nuts'],
    pad: ['pads', 'brake pads'],
    pads: ['brake pads'],
    rotor: ['rotors', 'brake rotors'],
    rotors: ['rotor', 'brake rotors'],
    factory: ['stock', 'oem'],
    stock: ['factory', 'oem'],
    lift: ['lifted', 'lifts'],
    lifts: ['lift', 'lifted'],
    lifted: ['lift', 'lifts']
  };
  var MODEL_SEARCH_ALIASES = [
    { phrase: 'gr supra', make: 'Toyota', model: 'Supra', yearStart: 2019 },
    { phrase: 'a90 supra', make: 'Toyota', model: 'Supra', yearStart: 2019 },
    { phrase: 'a91 supra', make: 'Toyota', model: 'Supra', yearStart: 2019 },
    { phrase: 'mk5 supra', make: 'Toyota', model: 'Supra', yearStart: 2019 },
    { phrase: 'mkv supra', make: 'Toyota', model: 'Supra', yearStart: 2019 },
    { phrase: 'a80 supra', make: 'Toyota', model: 'Supra', yearStart: 1993, yearEnd: 2002 },
    { phrase: 'mk4 supra', make: 'Toyota', model: 'Supra', yearStart: 1993, yearEnd: 2002 },
    { phrase: 'mkiv supra', make: 'Toyota', model: 'Supra', yearStart: 1993, yearEnd: 2002 },
    { phrase: 'a70 supra', make: 'Toyota', model: 'Supra', yearStart: 1986, yearEnd: 1993 },
    { phrase: 'mk3 supra', make: 'Toyota', model: 'Supra', yearStart: 1986, yearEnd: 1993 },
    { phrase: 'mkiii supra', make: 'Toyota', model: 'Supra', yearStart: 1986, yearEnd: 1993 },
    { phrase: 'gtr', make: 'Nissan', model: 'GT-R' },
    { phrase: 'gt-r', make: 'Nissan', model: 'GT-R' },
    { phrase: 'r35', make: 'Nissan', model: 'GT-R', yearStart: 2007 },
    { phrase: 'evo', make: 'Mitsubishi', modelContains: 'evolution' },
    { phrase: 'miata', make: 'Mazda', modelContains: 'miata' },
    { phrase: 'mx5', make: 'Mazda', modelContains: 'mx-5' },
    { phrase: 'mx-5', make: 'Mazda', modelContains: 'mx-5' },
    { phrase: 'gr 86', make: 'Toyota', model: 'GR86' },
    { phrase: 'gr86', make: 'Toyota', model: 'GR86' },
    { phrase: 'gt 86', make: 'Toyota', model: '86' },
    { phrase: 'gt86', make: 'Toyota', model: '86' }
  ];
  var SEARCH_POSITION = {
    front: 1, rear: 1, rears: 1
  };
  var WHEEL_FILTER_TYPES = {
    'rim shells': true,
    'wheel pair': true,
    'wheel set': true,
    'wheel single': true
  };
  var WHEEL_QUERY_WORDS = {
    rim: 1, rims: 1, wheel: 1, wheels: 1
  };
  var WHEEL_FILTERS = [
    { key: 'diameter', field: 'diameter', label: 'Diameter', all: 'All diameters' },
    { key: 'boltPattern', field: 'boltPattern', label: 'Bolt pattern', all: 'All bolt patterns' },
    { key: 'colorFamily', field: 'colorFamily', label: 'Color', all: 'All colors' },
    { key: 'finish', field: 'finish', label: 'Finish', all: 'All finishes' },
    { key: 'wheelModel', field: 'wheelModel', label: 'Model', all: 'All models' },
    { key: 'fitment', field: 'fitment', label: 'Fitment', all: 'All fitments' },
    { key: 'frontSpecs', field: 'frontSpecs', label: 'Front specs', all: 'All front specs' },
    { key: 'rearSpecs', field: 'rearSpecs', label: 'Rear specs', all: 'All rear specs' }
  ];
  var WHEEL_BRANDS = [
    { name: 'Gram Lights', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/1_adf0926a-3c38-43a2-8ee6-69ba52d6149e.png?v=1787184115' },
    { name: 'Enkei', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/2_bc00cf06-d26d-4f31-9b12-15ab34871bda.png?v=1787184115' },
    { name: 'Volk Racing', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/3_c92ae6d8-133c-4f3e-9888-182167a7b2cc.png?v=1787184115' },
    { name: 'BBS', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/4_f996d6c2-eec2-442b-9e3e-a1d8db834f76.png?v=1787184115' },
    { name: 'Advan', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/5_74d0942c-152f-47a9-aebe-b4709e1f0397.png?v=1787184115' },
    { name: 'Rays Offroad', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/6_d2320b22-ae20-49b9-a044-8cc95687481e.png?v=1787184115' },
    { name: 'Mugen', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/7.png?v=1787184115' },
    { name: 'Nismo', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/8.png?v=1787184115' },
    { name: 'SSR', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/9.png?v=1787184115' },
    { name: 'Titan 7', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/10.png?v=1787184115' },
    { name: 'Spoon', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/11.png?v=1787184115' },
    { name: 'Desmond', icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/12.png?v=1787184115' }
  ];
  var WHEEL_BRAND_ICONS = {};
  WHEEL_BRANDS.forEach(function (brand) {
    WHEEL_BRAND_ICONS[brand.name] = brand.icon;
  });
  var emptyWheelFilters = {
    diameter: '',
    boltPattern: '',
    colorFamily: '',
    finish: '',
    wheelModel: '',
    fitment: '',
    frontSpecs: '',
    rearSpecs: ''
  };

  var ymmIndex = {};
  var ymmByToken = {};
  var ymmRowsAll = [];
  var ymmSearch = { makes: [], models: [], aliases: [] };
  var products = [];
  var wheelsProducts = [];
  var catalogReady = false;
  var catalogError = false;
  var wheelsInventoryReady = false;
  var wheelsInventoryError = false;
  var lightboxLastFocus = null;
  var lightboxIgnoreCloseUntil = 0;
  var searchPool = [];
  var searchPoolKey = '';
  var searchRaf = 0;
  var filterTimer = 0;
  var wheelSearchIndex = {};
  var syncingWheelFilters = false;
  var planCacheKey = '';
  var planCache = null;
  var browseCacheKeyVal = '';
  var browseCacheList = null;
  var filteredCacheKeyVal = '';
  var filteredCacheList = null;
  var lastGridIds = '';
  var cardEls = {};
  var ymmMakeNorm = {};
  var vehicleListKey = '';
  var vehicleListCache = null;

  var config = {
    collectionHandle: '',
    collectionId: null,
    collectionSource: 'none',
    pageSize: 250,
    productsCount: 0
  };
  try {
    var configEl = document.getElementById('wf-sr-config');
    if (configEl) config = Object.assign(config, JSON.parse(configEl.textContent || '{}'));
  } catch (err) {
    /* keep defaults */
  }

  try {
    var ymmMap = window.WF_YMM_MAP;
    if (!Array.isArray(ymmMap)) {
      var ymmMapEl = document.getElementById('wf-sr-ymm-map-data');
      ymmMap = ymmMapEl ? JSON.parse(ymmMapEl.textContent || '[]') : [];
    }
    ymmRowsAll = (Array.isArray(ymmMap) ? ymmMap : []).map(normalizeMapRow).filter(Boolean);
  } catch (err) {
    ymmRowsAll = [];
  }

  var state = {
    screen: 'ymm',
    vehicle: null,
    allProducts: false,
    wheelsInventory: false,
    queryVehicle: null,
    category: null,
    mode: 'category',
    query: '',
    vendors: [],
    subType: '',
    rideHeights: [],
    orientations: [],
    wheel: Object.assign({}, emptyWheelFilters),
    visibleCount: GRID_PAGE_SIZE,
    lightboxProductId: null,
    lightboxTab: 'details'
  };

  var yearEl = root.querySelector('[data-sr-year]');
  var makeEl = root.querySelector('[data-sr-make]');
  var modelEl = root.querySelector('[data-sr-model]');
  var formEl = root.querySelector('[data-sr-ymm-form]');
  var noticeEl = root.querySelector('[data-sr-notice]');
  var continueEl = root.querySelector('[data-sr-continue]');
  var searchAllEl = root.querySelector('[data-sr-search-all]');
  var wheelsInventoryEl = root.querySelector('[data-sr-wheels-inventory]');
  var loadEl = root.querySelector('[data-sr-load]');
  var backEl = root.querySelector('[data-sr-back]');
  var backLabelEl = root.querySelector('[data-sr-back-label]');
  var cartEl = root.querySelector('[data-sr-cart]');
  var cartCountEl = root.querySelector('[data-sr-cart-count]');
  var catsEl = root.querySelector('[data-sr-cats]');
  var catsEmptyEl = root.querySelector('[data-sr-cats-empty]');
  var vehicleEls = root.querySelectorAll('[data-sr-vehicle], [data-sr-vehicle-rail]');
  var railTitleEl = root.querySelector('[data-sr-rail-title]');
  var countEl = root.querySelector('[data-sr-count]');
  var browseEl = root.querySelector('[data-sr-browse]');
  var railFiltersEl = root.querySelector('[data-sr-rail-filters]');
  var filtersToggleEl = root.querySelector('[data-sr-filters-toggle]');
  var filtersToggleLabelEl = root.querySelector('[data-sr-filters-toggle-label]');
  var phoneFiltersOpen = false;
  var railSearchEl = root.querySelector('[data-sr-rail-search]');
  var searchFormEl = root.querySelector('[data-sr-search-form]');
  var searchEl = root.querySelector('[data-sr-search]');
  var vendorEl = root.querySelector('[data-sr-vendor]');
  var vendorPillsEl = root.querySelector('[data-sr-vendors]');
  var typesEl = root.querySelector('[data-sr-types]');
  var typeSelectEl = root.querySelector('[data-sr-type-select]');
  var typeFilterEl = root.querySelector('[data-sr-type-filter]');
  var wheelFiltersEl = root.querySelector('[data-sr-wheel-filters]');
  var kitFiltersEl = root.querySelector('[data-sr-kit-filters]');
  var rideHeightFilterEl = root.querySelector('[data-sr-ride-height-filter]');
  var rideHeightsEl = root.querySelector('[data-sr-ride-heights]');
  var orientationFilterEl = root.querySelector('[data-sr-orientation-filter]');
  var orientationsEl = root.querySelector('[data-sr-orientations]');
  var gridEl = root.querySelector('[data-sr-grid]');
  var moreEl = root.querySelector('[data-sr-more]');
  var loadMoreEl = root.querySelector('[data-sr-load-more]');
  var emptyEl = root.querySelector('[data-sr-empty]');
  var searchIdleEl = root.querySelector('[data-sr-search-idle]');
  var searchIdleTilesEl = root.querySelector('[data-sr-search-idle-tiles]');
  var searchIdleKey = '';
  var lightboxEl = root.querySelector('[data-sr-lightbox]');
  var lightboxImageEl = root.querySelector('[data-sr-lightbox-image]');
  var lightboxThumbsEl = root.querySelector('[data-sr-lightbox-thumbs]');
  var lightboxVendorEl = root.querySelector('[data-sr-lightbox-vendor]');
  var lightboxTitleEl = document.getElementById('wf-sr-lightbox-title');
  var lightboxPriceEl = root.querySelector('[data-sr-lightbox-price]');
  var lightboxScrollEl = root.querySelector('[data-sr-lightbox-scroll]');
  var lightboxDescEl = root.querySelector('[data-sr-lightbox-desc]');
  var lightboxFitmentEl = root.querySelector('[data-sr-lightbox-fitment]');
  var lightboxTabsEl = root.querySelector('[data-sr-lightbox-tabs]');
  var lightboxVariantEl = root.querySelector('[data-sr-lightbox-variant]');
  var lightboxVariantWrap = root.querySelector('[data-sr-lightbox-variant-wrap]');
  var lightboxAtcEl = root.querySelector('[data-sr-atc]');

  function absUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isPhone() {
    return window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
  }

  function uniqueSorted(values) {
    var seen = {};
    var out = [];
    (values || []).forEach(function (value) {
      var key = String(value || '').trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    return out.sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function uniqueList(values) {
    var seen = {};
    var out = [];
    (values || []).forEach(function (value) {
      var key = String(value || '').trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    return out;
  }

  function listItemText(item) {
    if (item == null) return '';
    if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
    if (typeof item === 'object') {
      if (item.value != null && item.value !== item) return listItemText(item.value);
      if (item.name != null && item.name !== item) return listItemText(item.name);
    }
    var text = String(item).trim();
    return text === '[object Object]' ? '' : text;
  }

  function asStringList(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value.map(listItemText).filter(Boolean);
    return [listItemText(value)].filter(Boolean);
  }

  function normalizeCatKey(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isAllowedType(name) {
    return !!ALLOWED_TYPES[normalizeCatKey(name)];
  }

  function categorySortIndex(name) {
    var key = normalizeCatKey(name);
    var exact = CATEGORY_SORT.indexOf(key);
    return exact === -1 ? 1000 : exact;
  }

  function productTypeList(product) {
    if (product && product._typeList) return product._typeList;
    var seen = {};
    var list = [];
    function add(value) {
      var text = String(value || '').trim();
      if (!text) return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      list.push(text);
    }
    add(product && product.type);
    asStringList(product && product.subTypes).forEach(add);
    if (product) product._typeList = list;
    return list;
  }

  function productPartTypes(product) {
    var type = String(product && product.type || '').trim();
    return type && isAllowedType(type) ? [type] : [];
  }

  function productSubTypes(product) {
    return asStringList(product && product.subTypes);
  }

  function isWheelCategory(name) {
    return !!WHEEL_FILTER_TYPES[normalizeCatKey(name)];
  }

  function productWheelValue(product, field) {
    return String(product && product[field] != null ? product[field] : '').trim();
  }

  function hasAnyWheelField(product) {
    var i;
    for (i = 0; i < WHEEL_FILTERS.length; i++) {
      if (productWheelValue(product, WHEEL_FILTERS[i].field)) return true;
    }
    return false;
  }

  function isWheelProduct(product) {
    return isWheelCategory(product && product.type) || hasAnyWheelField(product);
  }

  function compactWheelText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/["″]/g, '')
      .replace(/[\s\-_/,]/g, '');
  }

  function addWheelIndexToken(value) {
    var compact = compactWheelText(value);
    if (compact) wheelSearchIndex[compact] = true;
  }

  function indexProductWheelMappings(product) {
    productWheelSearchParts(product).forEach(addWheelIndexToken);
  }

  function rebuildWheelSearchIndex() {
    wheelSearchIndex = {};
    products.forEach(indexProductWheelMappings);
    if (wheelsProducts !== products) {
      wheelsProducts.forEach(indexProductWheelMappings);
    }
  }

  function catalogHandlesMatch() {
    return String(config.collectionHandle || '').toLowerCase() === WHEELS_INVENTORY_HANDLE;
  }

  function isSuspensionKitsCatalog() {
    if (state.wheelsInventory) return false;
    if (SUSPENSION_KITS_COLLECTION_IDS[String(config.collectionId || '')]) return true;
    return String(config.collectionHandle || '').toLowerCase() === SUSPENSION_KITS_HANDLE;
  }

  function activeCatalog() {
    return state.wheelsInventory ? wheelsProducts : products;
  }

  function emptyWheelState() {
    return Object.assign({}, emptyWheelFilters);
  }

  function clearWheelFilters() {
    state.wheel = emptyWheelState();
  }

  function hasWheelFilter() {
    var i;
    for (i = 0; i < WHEEL_FILTERS.length; i++) {
      if (state.wheel[WHEEL_FILTERS[i].key]) return true;
    }
    return false;
  }

  function selectedVendors() {
    return Array.isArray(state.vendors) ? state.vendors : [];
  }

  function productMatchesVendors(product) {
    var selected = selectedVendors();
    if (!selected.length) return true;
    return selected.indexOf(product.vendor) !== -1;
  }

  function clearVendorFilters() {
    state.vendors = [];
  }

  function selectedRideHeights() {
    return Array.isArray(state.rideHeights) ? state.rideHeights : [];
  }

  function selectedOrientations() {
    return Array.isArray(state.orientations) ? state.orientations : [];
  }

  function clearSuspensionFilters() {
    state.rideHeights = [];
    state.orientations = [];
  }

  function hasSuspensionFilter() {
    return selectedRideHeights().length > 0 || selectedOrientations().length > 0;
  }

  function productRideHeights(product) {
    if (product && product._rideHeights) return product._rideHeights;
    var list = asStringList(product && product.rideHeights);
    if (product) product._rideHeights = list;
    return list;
  }

  function productOrientation(product) {
    return String(product && product.orientation != null ? product.orientation : '').trim();
  }

  function parseRideHeightAmount(text) {
    var raw = String(text || '').trim().toLowerCase();
    if (/^(factory|stock|oem)$/.test(raw)) return { factory: true };
    var quoted = /["″]/.test(raw);
    var compact = raw.replace(/["″]/g, '').replace(/\s+/g, '');
    var match = compact.match(/^(\d+(?:\.\d+)?)(?:in(?:ch(?:es)?)?)?$/);
    if (!match) return null;
    var inches = parseFloat(match[1]);
    if (isNaN(inches) || inches > 20) return null;
    var hasUnit = quoted || /(?:in(?:ch(?:es)?)?)$/.test(compact);
    if (!hasUnit && compact === match[1]) return { inches: inches, bare: true };
    return { inches: inches };
  }

  function rideHeightValueMatchesHint(value, hint) {
    if (!hint) return false;
    var raw = String(value || '').trim();
    if (hint.factory) return /^(factory|stock|oem)$/i.test(raw);
    if (hint.inches == null) return false;
    var parsed = parseRideHeightAmount(raw);
    if (!parsed || parsed.factory || parsed.inches == null) return false;
    return Math.abs(parsed.inches - hint.inches) < 0.051;
  }

  function productMatchesRideHeightHints(product, hints) {
    if (!hints || !hints.length) return true;
    var values = productRideHeights(product);
    var i;
    var j;
    for (i = 0; i < hints.length; i++) {
      for (j = 0; j < values.length; j++) {
        if (rideHeightValueMatchesHint(values[j], hints[i])) return true;
      }
    }
    return false;
  }

  function productMatchesOrientationHints(product, hints) {
    if (!hints || !hints.length) return true;
    var value = productOrientation(product);
    if (!value) return false;
    return hints.indexOf(value) !== -1;
  }

  function productMatchesRideHeights(product) {
    var selected = selectedRideHeights();
    if (!selected.length) return true;
    var values = productRideHeights(product);
    var i;
    for (i = 0; i < selected.length; i++) {
      if (values.indexOf(selected[i]) !== -1) return true;
    }
    return false;
  }

  function productMatchesOrientations(product) {
    var selected = selectedOrientations();
    if (!selected.length) return true;
    var value = productOrientation(product);
    return !!value && selected.indexOf(value) !== -1;
  }

  function matchesSuspensionFilters(product, exceptKey) {
    if (exceptKey !== 'rideHeights' && !productMatchesRideHeights(product)) return false;
    if (exceptKey !== 'orientations' && !productMatchesOrientations(product)) return false;
    return true;
  }

  function sortRideHeightValues(values) {
    return uniqueList(values).sort(function (a, b) {
      var fa = /^(factory|stock|oem)$/i.test(a);
      var fb = /^(factory|stock|oem)$/i.test(b);
      if (fa && !fb) return -1;
      if (fb && !fa) return 1;
      var na = parseRideHeightAmount(a);
      var nb = parseRideHeightAmount(b);
      var ia = na && na.inches != null ? na.inches : NaN;
      var ib = nb && nb.inches != null ? nb.inches : NaN;
      if (!isNaN(ia) && !isNaN(ib) && ia !== ib) return ia - ib;
      return a.localeCompare(b);
    });
  }

  function sortOrientationValues(values) {
    return uniqueList(values).sort(function (a, b) {
      var ia = ORIENTATION_SORT.indexOf(a);
      var ib = ORIENTATION_SORT.indexOf(b);
      if (ia === -1) ia = 100;
      if (ib === -1) ib = 100;
      if (ia !== ib) return ia - ib;
      return a.localeCompare(b);
    });
  }

  function toggleSelectedValue(list, value) {
    var next = (list || []).slice();
    var index = next.indexOf(value);
    if (index === -1) next.push(value);
    else next.splice(index, 1);
    return next;
  }

  function matchesNonWheelFilters(product, exceptKitKey) {
    if (!productMatchesVendors(product)) return false;
    if (state.subType && productSubTypes(product).indexOf(state.subType) === -1) return false;
    if (!matchesSuspensionFilters(product, exceptKitKey)) return false;
    return true;
  }

  function matchesWheelFilters(product, exceptKey) {
    var i;
    var spec;
    var selected;
    for (i = 0; i < WHEEL_FILTERS.length; i++) {
      spec = WHEEL_FILTERS[i];
      if (exceptKey && spec.key === exceptKey) continue;
      selected = state.wheel[spec.key];
      if (!selected) continue;
      if (productWheelValue(product, spec.field) !== selected) return false;
    }
    return true;
  }

  function isAvailable(product) {
    return product && product.available === true;
  }

  function isCatalogProduct(product) {
    return isAllowedType(product && product.type);
  }

  function productYmmTags(product) {
    if (product && product._ymmTags) return product._ymmTags;
    var tags = Array.isArray(product && product.tags) ? product.tags : [];
    var list = tags.filter(function (tag) {
      return String(tag || '').indexOf('YMM_') === 0;
    });
    if (product) product._ymmTags = list;
    return list;
  }

  function cleanFitmentLabel(value) {
    return String(value || '')
      .replace(/^[\s\[\]"']+|[\s\[\]"']+$/g, '')
      .trim();
  }

  function productVehicleGroups(product) {
    if (product && product._vehicleGroups) return product._vehicleGroups;
    var list = asStringList(product && product.vehicleGroups).map(cleanFitmentLabel).filter(Boolean);
    if (product) product._vehicleGroups = list;
    return list;
  }

  function productFitmentList(product) {
    if (product && product._fitmentList) return product._fitmentList;
    var list = asStringList(product && product.fitmentList).map(cleanFitmentLabel).filter(Boolean);
    if (product) product._fitmentList = list;
    return list;
  }

  function productFitmentLabels(product) {
    if (product && product._fitmentLabels) return product._fitmentLabels;
    var list = uniqueList(productVehicleGroups(product).concat(productFitmentList(product)));
    if (product) product._fitmentLabels = list;
    return list;
  }

  function productFitmentNorm(product) {
    if (product && product._fitmentNorm) return product._fitmentNorm;
    var list = productFitmentLabels(product).map(function (label) {
      return {
        raw: label,
        text: ' ' + normalizeSearchText(label) + ' '
      };
    });
    if (product) product._fitmentNorm = list;
    return list;
  }

  function paddedHasWord(paddedHay, word) {
    var needle = normalizeSearchText(word);
    if (!paddedHay || !needle) return false;
    return paddedHay.indexOf(' ' + needle + ' ') !== -1;
  }

  function hasUniversalYmmTag(tags) {
    var i;
    for (i = 0; i < tags.length; i++) {
      if (String(tags[i] || '').toUpperCase() === UNIVERSAL_YMM_TAG) return true;
    }
    return false;
  }

  function normalizeSearchText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function textHasWord(hay, word) {
    var needle = normalizeSearchText(word);
    var text = normalizeSearchText(hay);
    if (!text || !needle) return false;
    if (text === needle) return true;
    return (' ' + text + ' ').indexOf(' ' + needle + ' ') !== -1;
  }

  function hayHasOtherMake(hay, make) {
    var wanted = normalizeSearchText(make);
    var text = ' ' + normalizeSearchText(hay) + ' ';
    var key;
    for (key in ymmMakeNorm) {
      if (!Object.prototype.hasOwnProperty.call(ymmMakeNorm, key) || key === wanted) continue;
      if (text.indexOf(' ' + key + ' ') !== -1) return true;
    }
    return false;
  }

  function chassisCodesForRow(row) {
    if (!row || !row.ymm) return [];
    var skip = {};
    rawSearchTokens([row.yearStart, row.yearEnd, row.yearRange, row.make, row.model].join(' ')).forEach(function (token) {
      skip[token] = true;
    });
    return String(row.ymm)
      .replace(/^YMM_/i, '')
      .split('_')
      .map(function (part) {
        return String(part || '').trim().toLowerCase();
      })
      .filter(function (part) {
        if (!part || skip[part]) return false;
        if (/^(19|20)\d{2}$/.test(part)) return false;
        if (/^[ivx]+$/.test(part) && part.length <= 4) return false;
        return /[0-9]/.test(part) && part.length >= 2;
      });
  }

  function chassisCodesForRows(rows) {
    var seen = {};
    var out = [];
    (rows || []).forEach(function (row) {
      chassisCodesForRow(row).forEach(function (code) {
        if (seen[code]) return;
        seen[code] = true;
        out.push(code);
      });
    });
    return out;
  }

  function compactSearchText(value) {
    return normalizeSearchText(value).replace(/\s+/g, '');
  }

  function rowsNamedLike(make, model, modelContains) {
    var wantedMake = normalizeSearchText(make);
    var wantedModel = normalizeSearchText(model);
    var wantedCompact = compactSearchText(model);
    var contains = normalizeSearchText(modelContains || model);
    return ymmRowsAll.filter(function (row) {
      if (!row) return false;
      if (wantedMake && normalizeSearchText(row.make) !== wantedMake) return false;
      var rowModel = normalizeSearchText(row.model);
      if (!rowModel) return false;
      if (wantedModel && rowModel === wantedModel) return true;
      if (wantedCompact && wantedCompact.length >= 3 && compactSearchText(row.model) === wantedCompact) return true;
      if (!contains || contains.length < 3) return false;
      return textHasWord(rowModel, contains);
    });
  }

  function rowOverlapsYears(row, year, yearStart, yearEnd) {
    var span = parseYearRange(row);
    if (!span.start) return false;
    if (year) {
      var y = parseInt(year, 10);
      return y >= span.start && y <= span.end;
    }
    var start = parseInt(yearStart, 10) || 0;
    var end = parseInt(yearEnd, 10) || 0;
    if (start && end) return span.start <= end && span.end >= start;
    if (start) return span.end >= start;
    if (end) return span.start <= end;
    return true;
  }

  function labelForFitmentVehicle(spec, rows) {
    var year = spec.year ? String(spec.year) : '';
    var make = spec.make || (rows[0] && rows[0].make) || '';
    var model = spec.model || spec.modelContains || (rows[0] && rows[0].model) || '';
    if (year) return [year, make, model].filter(Boolean).join(' ');
    if (spec.yearStart && spec.yearEnd && spec.yearStart !== spec.yearEnd) {
      return [spec.yearStart + '-' + spec.yearEnd, make, model].filter(Boolean).join(' ');
    }
    if (spec.yearStart) return [spec.yearStart + '+', make, model].filter(Boolean).join(' ');
    return [make, model].filter(Boolean).join(' ') || model;
  }

  function normalizeMapRow(row) {
    if (!row) return null;
    if (Array.isArray(row)) {
      row = {
        ymm: row[0],
        yearStart: row[1],
        yearEnd: row[2],
        make: row[3],
        model: row[4]
      };
    }
    var ymm = String(row.ymm || '').trim();
    var make = String(row.make || '').trim();
    var model = String(row.model || '').trim();
    var yearStart = parseInt(row.yearStart, 10);
    var yearEnd = parseInt(row.yearEnd, 10);
    if (!ymm || !make || !model || !yearStart) return null;
    if (!yearEnd) yearEnd = yearStart;
    var yearRange = row.yearRange || (yearStart + '-' + yearEnd);
    var label = row.label || row.fitment || (yearRange + ' ' + make + ' ' + model);
    return {
      ymm: ymm,
      yearStart: yearStart,
      yearEnd: yearEnd,
      yearRange: yearRange,
      make: make,
      model: model,
      label: label,
      fitment: row.fitment || label
    };
  }

  function parseYearRange(row) {
    var start = parseInt(row && row.yearStart, 10);
    var end = parseInt(row && row.yearEnd, 10);
    if (!start && row && row.yearRange) {
      var match = String(row.yearRange).match(/^(\d{4})\s*-\s*(\d{4})$/);
      if (match) {
        start = parseInt(match[1], 10);
        end = parseInt(match[2], 10);
      }
    }
    if (!end) end = start;
    return { start: start || 0, end: end || 0 };
  }

  function rowsForVehicle(year, make, model) {
    var map = year && ymmIndex[year] && ymmIndex[year][make] ? ymmIndex[year][make][model] : null;
    return Array.isArray(map) ? map : [];
  }

  function tagsFromRows(rows) {
    return uniqueList((rows || []).map(function (row) {
      return row && row.ymm;
    }));
  }

  function decorateVehicle(vehicle, rows) {
    if (!vehicle) return null;
    var selected = rows && rows.length ? rows : [];
    vehicle.chassis = chassisCodesForRows(selected);
    vehicle.otherChassis = [];
    vehicle.spanStart = 0;
    vehicle.spanEnd = 0;
    vehicle.familyNewest = 0;
    selected.forEach(function (row) {
      var span = parseYearRange(row);
      if (!span.start) return;
      if (!vehicle.spanStart || span.start < vehicle.spanStart) vehicle.spanStart = span.start;
      if (span.end > vehicle.spanEnd) vehicle.spanEnd = span.end;
    });
    if (vehicle.make && vehicle.model) {
      var family = rowsNamedLike(vehicle.make, vehicle.model, vehicle.modelContains);
      var selectedCodes = {};
      vehicle.chassis.forEach(function (code) { selectedCodes[code] = true; });
      chassisCodesForRows(family).forEach(function (code) {
        if (!selectedCodes[code]) vehicle.otherChassis.push(code);
      });
      family.forEach(function (row) {
        var start = parseInt(row.yearStart, 10) || 0;
        if (start > vehicle.familyNewest) vehicle.familyNewest = start;
      });
    }
    return vehicle;
  }

  function vehicleFromSelection(year, make, model) {
    if (!year || !make || !model) return null;
    var rows = rowsForVehicle(year, make, model);
    if (!rows.length) return null;
    return decorateVehicle({
      year: String(year),
      make: make,
      model: model,
      tags: tagsFromRows(rows),
      ymm: rows[0].ymm || [year, make, model].join('_'),
      label: [year, make, model].join(' '),
      fitment: rows[0].fitment || rows[0].label || ''
    }, rows);
  }

  function vehicleFromModelSearch(spec) {
    if (!spec || (!spec.model && !spec.modelContains)) return null;
    var rows = rowsNamedLike(spec.make, spec.model, spec.modelContains).filter(function (row) {
      return rowOverlapsYears(row, spec.year, spec.yearStart, spec.yearEnd);
    });
    if (!rows.length && spec.make) {
      rows = rowsNamedLike('', spec.model, spec.modelContains).filter(function (row) {
        return rowOverlapsYears(row, spec.year, spec.yearStart, spec.yearEnd);
      });
    }
    if (!rows.length) return null;
    var makes = uniqueList(rows.map(function (row) { return row.make; }));
    var models = uniqueList(rows.map(function (row) { return row.model; }));
    var displayMake = spec.make || (makes.length === 1 ? makes[0] : '');
    var displayModel = spec.model || '';
    if (!displayModel && spec.modelContains) {
      displayModel = models.filter(function (name) {
        return normalizeSearchText(name) === normalizeSearchText(spec.modelContains);
      })[0] || models[0] || spec.modelContains;
    } else if (!displayModel) {
      displayModel = models.length === 1 ? models[0] : '';
    }
    var vehicle = {
      year: spec.year ? String(spec.year) : '',
      make: displayMake,
      model: displayModel,
      modelContains: spec.modelContains || '',
      tags: tagsFromRows(rows),
      ymm: rows[0].ymm || [spec.year, spec.make, spec.model].filter(Boolean).join('_'),
      label: labelForFitmentVehicle({
        year: spec.year,
        make: displayMake,
        model: displayModel,
        yearStart: spec.yearStart,
        yearEnd: spec.yearEnd
      }, rows),
      fitment: rows[0].fitment || rows[0].label || '',
      soft: !spec.year
    };
    return decorateVehicle(vehicle, rows);
  }

  function productMatchesVehicleGroup(product, vehicle) {
    var groups = productFitmentNorm(product);
    if (!groups.length || !vehicle) return false;
    var model = vehicle.model || '';
    var contains = vehicle.modelContains || '';
    var make = vehicle.make || '';
    var chassis = vehicle.chassis || [];
    var otherChassis = vehicle.otherChassis || [];
    var i;
    var row;
    var hay;
    var hasModel;
    var hasChassis;
    var hasOther;
    for (i = 0; i < groups.length; i++) {
      row = groups[i];
      hay = row.text;
      if (!hay) continue;
      hasModel = (model && paddedHasWord(hay, model)) || (contains && paddedHasWord(hay, contains));
      hasChassis = chassis.some(function (code) {
        return paddedHasWord(hay, code);
      });
      hasOther = otherChassis.some(function (code) {
        return paddedHasWord(hay, code);
      });
      if (hasOther && !hasChassis) continue;
      if (hasModel && paddedHasWord(hay, 'gr') && !hasChassis && vehicle.spanEnd && vehicle.familyNewest && vehicle.spanEnd < vehicle.familyNewest) {
        continue;
      }
      if ((hasModel || hasChassis) && !labelOverlapsVehicleYears(row.raw, vehicle)) continue;
      if ((hasModel || hasChassis) && make && !paddedHasWord(hay, make) && hayHasOtherMake(row.raw, make)) {
        continue;
      }
      if (hasModel || hasChassis) return true;
    }
    return false;
  }

  function titleYearRangeSpans(product) {
    if (product && product._titleYearRanges) return product._titleYearRanges;
    var spans = [];
    var raw = String(product && product.title || '');
    var re = /(19|20)\d{2}\s*[-–—]\s*(19|20)\d{2}/g;
    var match;
    var start;
    var end;
    while ((match = re.exec(raw))) {
      start = parseInt(match[0].slice(0, 4), 10);
      end = parseInt(match[0].slice(-4), 10);
      if (start && end && end >= start && end - start <= 40) spans.push({ start: start, end: end });
    }
    if (product) product._titleYearRanges = spans;
    return spans;
  }

  function productTitleConflictsVehicleYear(product, vehicle) {
    var year = parseInt(vehicle && vehicle.year, 10) || 0;
    if (!year) return false;
    var spans = titleYearRangeSpans(product);
    if (!spans.length) return false;
    return !spans.some(function (span) {
      return year >= span.start && year <= span.end;
    });
  }

  function matchesVehicleTags(product, vehicle) {
    if (!vehicle) return false;
    if (productTitleConflictsVehicleYear(product, vehicle)) return false;
    var tags = productYmmTags(product);
    if (hasUniversalYmmTag(tags)) return true;
    var needed = vehicle.tags || [];
    var set = product._ymmTagSet;
    var i;
    if (!set) {
      set = {};
      for (i = 0; i < tags.length; i++) set[tags[i]] = true;
      product._ymmTagSet = set;
    }
    if (needed.length) {
      for (i = 0; i < needed.length; i++) {
        if (set[needed[i]]) return true;
      }
    }
    return productMatchesVehicleGroup(product, vehicle);
  }

  function matchesVehicle(product) {
    if (state.allProducts) return true;
    return matchesVehicleTags(product, state.vehicle);
  }

  function vehicleProducts() {
    var key = vehicleKey() + '|' + (state.allProducts ? '1' : '0') + '|' + activeCatalog().length;
    if (vehicleListKey === key && vehicleListCache) return vehicleListCache;
    vehicleListCache = activeCatalog().filter(function (product) {
      return isAvailable(product) && isCatalogProduct(product) && matchesVehicle(product);
    });
    vehicleListKey = key;
    return vehicleListCache;
  }

  function categoryProducts() {
    var list = vehicleProducts();
    if (state.wheelsInventory) return list;
    return list.filter(function (product) {
      return productPartTypes(product).indexOf(state.category) !== -1;
    });
  }

  function isSearchCode(token) {
    var text = String(token || '').trim().toLowerCase();
    if (text.length < 4 || text.length > 32) return false;
    if (/^(19|20)\d{2}$/.test(text)) return false;
    if (/^(19|20)\d{2}[-/](19|20)\d{2}$/.test(text)) return false;
    if (/^\d+\.\d{2}$/.test(text)) return false;
    if (!/\d/.test(text)) return false;
    if (/[a-z]/.test(text) || /[-/.]/.test(text)) return true;
    return text.replace(/\D/g, '').length >= 6;
  }

  function extractSearchCodes(text) {
    var raw = String(text || '');
    if (!raw) return [];
    var tokens = raw.split(/[^A-Za-z0-9.\-\/]+/);
    var out = [];
    var seen = {};
    var i;
    var token;
    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];
      if (!isSearchCode(token) || seen[token]) continue;
      seen[token] = true;
      out.push(token.toLowerCase());
    }
    return out;
  }

  function productSkuList(product) {
    if (product._skus) return product._skus;
    var seen = {};
    var list = [];
    function add(value) {
      var sku = String(value || '').trim().toLowerCase();
      if (!sku || seen[sku]) return;
      seen[sku] = true;
      list.push(sku);
    }
    add(product.sku);
    (product.variants || []).forEach(function (variant) {
      if (!variant) return;
      add(variant.sku);
      add(variant.barcode);
    });
    (product.extraSkus || []).forEach(add);
    extractSearchCodes(product.codeText).forEach(add);
    product._skus = list;
    if (product.codeText) product.codeText = '';
    return list;
  }

  function yearSpansFromText(text) {
    var spans = [];
    var raw = String(text || '');
    var re = /(19|20)\d{2}\s*[-–—]\s*(19|20)\d{2}/g;
    var match;
    var start;
    var end;
    while ((match = re.exec(raw))) {
      start = parseInt(match[0].slice(0, 4), 10);
      end = parseInt(match[0].slice(-4), 10);
      if (start && end && end >= start && end - start <= 40) spans.push({ start: start, end: end });
    }
    if (spans.length) return spans;
    re = /\b((?:19|20)\d{2})\b/g;
    while ((match = re.exec(raw))) {
      start = parseInt(match[1], 10);
      if (start >= 1950 && start <= 2035) spans.push({ start: start, end: start });
    }
    return spans;
  }

  function addYearsFromSpan(years, start, end) {
    var year;
    for (year = start; year <= end; year++) years[year] = true;
  }

  function productFitmentYears(product) {
    if (product._fitYears) return product._fitYears;
    var years = {};
    productYmmTags(product).forEach(function (tag) {
      var row = ymmByToken[tag];
      if (!row) return;
      var span = parseYearRange(row);
      addYearsFromSpan(years, span.start, span.end);
    });
    productFitmentLabels(product).forEach(function (label) {
      yearSpansFromText(label).forEach(function (span) {
        addYearsFromSpan(years, span.start, span.end);
      });
    });
    product._fitYears = years;
    return years;
  }

  function productOverlapsYearSpan(product, start, end) {
    var years = productFitmentYears(product);
    var year;
    for (year = start; year <= end; year++) {
      if (years[year]) return true;
    }
    return false;
  }

  function productFitmentSearchParts(product) {
    var parts = [];
    var seen = {};
    function add(value) {
      var text = String(value || '').trim();
      if (!text) return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      parts.push(text);
    }
    productYmmTags(product).forEach(function (tag) {
      add(tag);
      var row = ymmByToken[tag];
      if (!row) return;
      add(row.make);
      add(row.model);
      add(row.label);
      add(row.fitment);
      add(row.yearRange);
      chassisCodesForRow(row).forEach(add);
      var span = parseYearRange(row);
      add(String(span.start));
      add(String(span.end));
      add(span.start + '-' + span.end);
    });
    productFitmentLabels(product).forEach(add);
    return parts;
  }

  function labelOverlapsVehicleYears(label, vehicle) {
    var spans = yearSpansFromText(label);
    if (!spans.length || !vehicle) return true;
    var start = parseInt(vehicle.year || vehicle.spanStart, 10) || 0;
    var end = parseInt(vehicle.year || vehicle.spanEnd, 10) || start;
    if (!start) return true;
    return spans.some(function (span) {
      return start <= span.end && end >= span.start;
    });
  }

  function productTypeSearchParts(product) {
    var parts = [];
    var seen = {};
    function add(value) {
      var text = String(value || '').trim();
      if (!text) return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      parts.push(text);
      if (text.indexOf('-') === -1) return;
      var open = text.replace(/-/g, '');
      if (open && !seen[open.toLowerCase()]) {
        seen[open.toLowerCase()] = true;
        parts.push(open);
      }
      var spaced = text.replace(/-/g, ' ');
      if (spaced && !seen[spaced.toLowerCase()]) {
        seen[spaced.toLowerCase()] = true;
        parts.push(spaced);
      }
    }
    productTypeList(product).forEach(add);
    return parts;
  }

  function productWheelSearchParts(product) {
    if (product && product._wheelParts) return product._wheelParts;
    var parts = [];
    var seen = {};

    function add(value) {
      var text = String(value || '').trim();
      if (!text) return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      parts.push(text);
      if (text.indexOf('-') !== -1) {
        var open = text.replace(/-/g, '');
        if (open && !seen[open.toLowerCase()]) {
          seen[open.toLowerCase()] = true;
          parts.push(open);
        }
        var spaced = text.replace(/-/g, ' ');
        if (spaced && !seen[spaced.toLowerCase()]) {
          seen[spaced.toLowerCase()] = true;
          parts.push(spaced);
        }
      }
      var compact = compactWheelText(text);
      if (compact && !seen[compact]) {
        seen[compact] = true;
        parts.push(compact);
      }
    }

    WHEEL_FILTERS.forEach(function (spec) {
      add(productWheelValue(product, spec.field));
    });

    var diameter = productWheelValue(product, 'diameter');
    if (diameter) {
      (diameter.match(/\d+(?:\.\d+)?/g) || []).forEach(function (num) {
        add(num);
        add(num + '"');
        add(num + 'in');
        add(num + 'inch');
        add(num + 'inches');
      });
    }

    var bolt = productWheelValue(product, 'boltPattern');
    if (bolt) {
      add(bolt.replace(/x/ig, '-'));
      add(bolt.replace(/x/ig, '/'));
      add(bolt.replace(/x/ig, ' '));
    }

    [productWheelValue(product, 'frontSpecs'), productWheelValue(product, 'rearSpecs')].forEach(function (spec) {
      if (!spec) return;
      spec.split(/[,;/|]/).forEach(function (chunk) {
        add(chunk);
        var size = chunk.match(/\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?/i);
        if (size) add(size[0].replace(/\s+/g, ''));
        var offset = chunk.match(/[+\-]\s*\d+(?:\.\d+)?/);
        if (offset) {
          add(offset[0].replace(/\s+/g, ''));
          add(offset[0].replace(/[+\-\s]/g, ''));
        }
      });
    });

    if (product) product._wheelParts = parts;
    return parts;
  }

  function productWheelList(product) {
    if (product && product._wheelList) return product._wheelList;
    var list = uniqueList(productWheelSearchParts(product).map(function (part) {
      return String(part || '').toLowerCase();
    }));
    if (product) product._wheelList = list;
    return list;
  }

  function productRideHeightSearchParts(product) {
    if (product && product._rideHeightParts) return product._rideHeightParts;
    var parts = [];
    var seen = {};
    var hasLift = false;

    function add(value) {
      var text = String(value || '').trim();
      if (!text) return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      parts.push(text);
    }

    productRideHeights(product).forEach(function (value) {
      add(value);
      var parsed = parseRideHeightAmount(value);
      if (parsed && parsed.factory) {
        add('factory');
        add('stock');
        add('oem');
        return;
      }
      if (!parsed || parsed.inches == null) return;
      hasLift = parsed.inches > 0;
      var n = parsed.inches;
      var whole = n === Math.floor(n);
      var num = whole ? String(n) : String(n);
      add(num + 'in');
      add(num + 'inch');
      add(num + 'inches');
      add(num + '-inch');
      add(num + '-inches');
      add(num + '"');
      add(num + ' in');
      add(num + ' inch');
      add(num + ' inches');
    });

    if (hasLift) {
      add('lift');
      add('lifted');
      add('lifts');
    }

    if (product) product._rideHeightParts = parts;
    return parts;
  }

  function productRideHeightList(product) {
    if (product && product._rideHeightList) return product._rideHeightList;
    var list = uniqueList(productRideHeightSearchParts(product).map(function (part) {
      return String(part || '').toLowerCase();
    }));
    if (product) product._rideHeightList = list;
    return list;
  }

  function productOrientationSearchParts(product) {
    if (product && product._orientationParts) return product._orientationParts;
    var value = productOrientation(product);
    var parts = [];
    if (value) {
      parts.push(value);
      parts.push(value.replace(/\s+/g, ''));
      String(value).toLowerCase().split(/\s+/).forEach(function (token) {
        if (token) parts.push(token);
      });
    }
    if (product) product._orientationParts = parts;
    return parts;
  }

  function productOrientationList(product) {
    if (product && product._orientationList) return product._orientationList;
    var list = uniqueList(productOrientationSearchParts(product).map(function (part) {
      return String(part || '').toLowerCase();
    }));
    if (product) product._orientationList = list;
    return list;
  }

  function productSearchText(product) {
    if (product._q) return product._q;
    var parts = [product.title, product.vendor, product.type, product.handle]
      .concat(productTypeSearchParts(product))
      .concat(productSkuList(product))
      .concat(productFitmentSearchParts(product))
      .concat(productWheelSearchParts(product))
      .concat(productRideHeightSearchParts(product))
      .concat(productOrientationSearchParts(product));
    product._q = parts.join(' ').toLowerCase();
    return product._q;
  }

  function prepareProductSearch(product) {
    if (!product || product._searchReady) return;
    productYmmTags(product);
    productFitmentLabels(product);
    productFitmentNorm(product);
    productFitmentYears(product);
    productSkuList(product);
    productTypeList(product);
    productWheelList(product);
    productRideHeightList(product);
    productOrientationList(product);
    productSearchText(product);
    product._searchReady = true;
  }

  function prepareCatalogSearch(list) {
    (list || []).forEach(prepareProductSearch);
  }

  function scheduleCatalogWarm(list) {
    if (!list || !list.length) return;
    var i = 0;
    function chunk() {
      var end = Math.min(i + 40, list.length);
      for (; i < end; i++) prepareProductSearch(list[i]);
      if (i >= list.length) return;
      if (window.requestIdleCallback) window.requestIdleCallback(chunk, { timeout: 200 });
      else window.setTimeout(chunk, 16);
    }
    chunk();
  }

  function clearSearchCaches() {
    planCacheKey = '';
    planCache = null;
    browseCacheKeyVal = '';
    browseCacheList = null;
    filteredCacheKeyVal = '';
    filteredCacheList = null;
    vehicleListKey = '';
    vehicleListCache = null;
  }

  function vehicleKey() {
    if (state.wheelsInventory) return '__wheels__';
    if (state.allProducts) return '__all__';
    if (!state.vehicle) return '';
    return state.vehicle.ymm || [state.vehicle.year, state.vehicle.make, state.vehicle.model].join('|');
  }

  function vehicleLabel() {
    if (state.queryVehicle && state.queryVehicle.label && (state.allProducts || !state.vehicle)) {
      return state.queryVehicle.label;
    }
    if (state.wheelsInventory) return 'Wheel inventory';
    if (state.allProducts) return 'All products';
    return state.vehicle && state.vehicle.label ? state.vehicle.label : '';
  }

  function ensureSearchPool() {
    var key = vehicleKey();
    if (searchPoolKey === key && searchPool.length) return searchPool;
    searchPool = vehicleProducts();
    prepareCatalogSearch(searchPool);
    searchPoolKey = key;
    return searchPool;
  }

  function rawSearchTokens(query) {
    return String(query || '')
      .toLowerCase()
      .replace(/[^\w.\-]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function findTokenPhrase(tokens, used, phrase) {
    if (!phrase || !phrase.length) return -1;
    var i;
    var j;
    var ok;
    for (i = 0; i <= tokens.length - phrase.length; i++) {
      ok = true;
      for (j = 0; j < phrase.length; j++) {
        if (used[i + j] || tokens[i + j] !== phrase[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return i;
    }
    return -1;
  }

  function markPhraseUsed(used, start, count) {
    var i;
    for (i = 0; i < count; i++) used[start + i] = true;
  }

  function modelNameAliases(make, model) {
    var names = [model];
    var makePrefix;
    if (!model) return names;
    if (make) {
      makePrefix = make.toLowerCase() + ' ';
      if (model.toLowerCase().indexOf(makePrefix) === 0) {
        names.push(model.slice(make.length).trim());
      }
    } else if (/^ram\s+/i.test(model)) {
      names.push(model.replace(/^ram\s+/i, '').trim());
    }
    return names.filter(Boolean);
  }

  function resolveParsedVehicle(year, make, model) {
    if (!year || !model || !ymmIndex[year]) return null;
    var yearMap = ymmIndex[year];
    var modelNames = modelNameAliases(make, model);
    var resolvedMake = make && yearMap[make] ? make : '';
    var resolvedModel = '';
    var makeName = '';
    var i;

    function hasModel(makeKey, modelName) {
      return !!(yearMap[makeKey] && yearMap[makeKey][modelName] && yearMap[makeKey][modelName].length);
    }

    for (i = 0; i < modelNames.length; i++) {
      if (resolvedMake && hasModel(resolvedMake, modelNames[i])) {
        resolvedModel = modelNames[i];
        break;
      }
    }

    if (!resolvedModel) {
      Object.keys(yearMap).forEach(function (key) {
        if (resolvedModel) return;
        for (i = 0; i < modelNames.length; i++) {
          if (hasModel(key, modelNames[i])) {
            if (resolvedMake && key !== resolvedMake) return;
            makeName = key;
            resolvedModel = modelNames[i];
            return;
          }
        }
      });
      if (!resolvedMake && makeName) resolvedMake = makeName;
    }

    return vehicleFromSelection(year, resolvedMake, resolvedModel);
  }

  function applyGrModelPrefix(tokens, used, spec) {
    var i;
    if (!spec.model || spec.yearStart || spec.modelContains) return spec;
    for (i = 0; i < tokens.length; i++) {
      if (used[i] || tokens[i] !== 'gr') continue;
      var grName = 'GR ' + spec.model;
      var grRows = rowsNamedLike(spec.make || 'Toyota', grName, '');
      used[i] = true;
      if (grRows.length) {
        spec.make = spec.make || grRows[0].make;
        spec.model = grRows[0].model;
        return spec;
      }
      var family = rowsNamedLike(spec.make, spec.model, spec.modelContains);
      var newest = 0;
      family.forEach(function (row) {
        var start = parseInt(row.yearStart, 10) || 0;
        if (start > newest) newest = start;
      });
      if (newest) spec.yearStart = newest;
      if (!spec.make && family.length) spec.make = family[0].make;
      return spec;
    }
    return spec;
  }

  function leftoverSearchTokens(tokens, used, vehicle) {
    var ignore = {};
    tokens.forEach(function (token, tokenIdx) {
      if (used[tokenIdx]) ignore[token] = true;
    });
    if (vehicle) {
      rawSearchTokens([
        vehicle.year,
        vehicle.make,
        vehicle.model,
        vehicle.modelContains,
        vehicle.label
      ].join(' ')).forEach(function (token) {
        ignore[token] = true;
      });
      if (vehicle.model) ignore[compactSearchText(vehicle.model)] = true;
      (vehicle.chassis || []).forEach(function (code) {
        ignore[String(code || '').toLowerCase()] = true;
      });
    }
    return tokens.filter(function (token, tokenIdx) {
      return !used[tokenIdx] && !SEARCH_STOP[token] && !ignore[token];
    });
  }

  function parseQueryFitment(query) {
    var tokens = rawSearchTokens(query);
    var used = tokens.map(function () { return false; });
    var spec = { year: '', make: '', model: '', modelContains: '', yearStart: 0, yearEnd: 0 };
    var i;
    var idx;
    var entry;

    for (i = 0; i < tokens.length; i++) {
      if (isSearchYearToken(tokens[i]) && ymmIndex[tokens[i]]) {
        if (!spec.year) spec.year = tokens[i];
        used[i] = true;
        continue;
      }
      var typedSpan = yearSpanFromToken(tokens[i]);
      if (typedSpan) {
        if (!spec.yearStart && !spec.yearEnd) {
          spec.yearStart = typedSpan.start;
          spec.yearEnd = typedSpan.end;
        }
        used[i] = true;
      }
    }

    var aliasHit = findIndexedPhrase(ymmSearch.aliasesByToken || {}, tokens, used);
    if (aliasHit) {
      entry = aliasHit.entry;
      spec.make = entry.make || spec.make;
      spec.model = entry.model || spec.model;
      spec.modelContains = entry.modelContains || spec.modelContains;
      if (!spec.year && !spec.yearStart && !spec.yearEnd) {
        spec.yearStart = entry.yearStart || spec.yearStart;
        spec.yearEnd = entry.yearEnd || spec.yearEnd;
      }
      markPhraseUsed(used, aliasHit.idx, entry.tokenCount);
    }

    if (!spec.model && !spec.modelContains) {
      var modelHit = findIndexedPhrase(ymmSearch.modelsByToken || {}, tokens, used);
      if (modelHit) {
        spec.model = modelHit.entry.name;
        markPhraseUsed(used, modelHit.idx, modelHit.entry.tokenCount);
      }
    }

    for (i = 0; i < ymmSearch.makes.length; i++) {
      entry = ymmSearch.makes[i];
      idx = findTokenPhrase(tokens, used, entry.tokens);
      if (idx !== -1) {
        spec.make = entry.name;
        markPhraseUsed(used, idx, entry.tokenCount);
        break;
      }
    }

    spec = applyGrModelPrefix(tokens, used, spec);

    var vehicle = null;
    if (spec.year && spec.model && !spec.modelContains && !spec.yearStart) {
      vehicle = resolveParsedVehicle(spec.year, spec.make, spec.model);
    }
    if (!vehicle && (spec.model || spec.modelContains)) {
      vehicle = vehicleFromModelSearch(spec);
    }

    if (!vehicle) {
      return {
        vehicle: null,
        tokens: tokens.filter(function (token) {
          return !SEARCH_STOP[token];
        })
      };
    }

    return {
      vehicle: vehicle,
      tokens: leftoverSearchTokens(tokens, used, vehicle)
    };
  }

  function queryUsesParsedVehicle() {
    return !!(state.allProducts || !state.vehicle);
  }

  function querySearchPlan(query) {
    var raw = String(query || '').trim();
    var key = raw + '|' + (queryUsesParsedVehicle() ? '1' : '0');
    if (planCache && planCacheKey === key) return planCache;
    var parsed = parseQueryFitment(raw);
    var useParsed = !!(parsed.vehicle && queryUsesParsedVehicle());
    planCacheKey = key;
    planCache = {
      raw: raw,
      vehicle: useParsed ? parsed.vehicle : null,
      tokens: useParsed ? parsed.tokens : searchTokens(raw)
    };
    return planCache;
  }

  function vehicleIgnoreTokens() {
    var ignore = {};
    var vehicle = state.vehicle || {};
    rawSearchTokens([
      vehicle.label,
      vehicle.ymm,
      vehicle.year,
      vehicle.make,
      vehicle.model,
      vehicle.fitment
    ].join(' ')).forEach(function (token) {
      ignore[token] = true;
    });
    if (vehicle.model) ignore[compactSearchText(vehicle.model)] = true;
    return ignore;
  }

  function searchTokens(query) {
    var ignore = vehicleIgnoreTokens();
    return rawSearchTokens(query).filter(function (token) {
      return !SEARCH_STOP[token] && !ignore[token];
    });
  }

  function tokenMatches(hay, token) {
    if (!hay || !token) return false;
    if (hay.indexOf(token) !== -1) return true;
    if (token.length > 4 && token.charAt(token.length - 1) === 's' && hay.indexOf(token.slice(0, -1)) !== -1) {
      return true;
    }
    if (token.indexOf('-') === -1 && hay.indexOf('-') === -1) return false;
    var hayOpen = hay.replace(/-/g, '');
    var tokenOpen = token.replace(/-/g, '');
    if (tokenOpen && hayOpen.indexOf(tokenOpen) !== -1) return true;
    if (tokenOpen.length > 4 && tokenOpen.charAt(tokenOpen.length - 1) === 's' && hayOpen.indexOf(tokenOpen.slice(0, -1)) !== -1) {
      return true;
    }
    return false;
  }

  function productTypeListMatches(product, token) {
    var values = productTypeList(product);
    var i;
    for (i = 0; i < values.length; i++) {
      if (tokenMatches(values[i].toLowerCase(), token)) return true;
    }
    return false;
  }

  function productWheelListMatches(product, token) {
    var values = productWheelList(product);
    var compact = compactWheelText(token);
    var i;
    for (i = 0; i < values.length; i++) {
      if (tokenMatches(values[i], token)) return true;
      if (compact && compactWheelText(values[i]) === compact) return true;
    }
    return false;
  }

  function productRideHeightListMatches(product, token) {
    var hint = parseRideHeightAmount(token);
    if (hint && !hint.bare) return productMatchesRideHeightHints(product, [hint]);
    var values = productRideHeightList(product);
    var i;
    for (i = 0; i < values.length; i++) {
      if (tokenMatches(values[i], token)) return true;
    }
    return false;
  }

  function productOrientationListMatches(product, token) {
    var values = productOrientationList(product);
    var i;
    for (i = 0; i < values.length; i++) {
      if (tokenMatches(values[i], token)) return true;
    }
    return false;
  }

  function rideHeightHintsFromQuery(raw) {
    var text = String(raw || '').toLowerCase();
    var hints = [];
    var seen = {};

    function add(hint) {
      var key = hint && hint.factory ? 'factory' : String(hint && hint.inches);
      if (!hint || seen[key]) return;
      seen[key] = true;
      hints.push(hint);
    }

    if (/\bfactory\b/.test(text)) add({ factory: true });
    var match;
    var re = /(\d+(?:\.\d+)?)\s*(?:["″]|in(?:ch(?:es)?)?)/g;
    while ((match = re.exec(text))) {
      var inches = parseFloat(match[1]);
      if (!isNaN(inches) && inches <= 20) add({ inches: inches });
    }
    return hints;
  }

  function mergeRideHeightHints(left, right) {
    var seen = {};
    var out = [];
    (left || []).concat(right || []).forEach(function (hint) {
      var key = hint && hint.factory ? 'factory' : String(hint && hint.inches);
      if (!hint || seen[key]) return;
      seen[key] = true;
      out.push(hint);
    });
    return out;
  }

  function extractKitSearchHints(tokens, includeOrientation) {
    var used = tokens.map(function () { return false; });
    var heights = [];
    var orientations = [];
    var i;
    var token;
    var next;
    var parsed;
    var phrase;
    var mapped;

    function addHeight(hint) {
      if (!hint || hint.bare) return;
      heights.push(hint);
    }

    for (i = 0; i < tokens.length; i++) {
      if (used[i]) continue;
      token = tokens[i];
      next = tokens[i + 1] || '';
      if (/^(factory|stock|oem)$/.test(token)) {
        used[i] = true;
        addHeight({ factory: true });
        continue;
      }
      parsed = parseRideHeightAmount(token);
      if (parsed && !parsed.bare) {
        used[i] = true;
        if (/^(lift|lifts|lifted|inch|inches|in)$/.test(next)) used[i + 1] = true;
        addHeight(parsed);
        continue;
      }
      if (parsed && parsed.bare && /^(in|inch|inches|lift|lifts|lifted)$/.test(next)) {
        used[i] = true;
        used[i + 1] = true;
        addHeight({ inches: parsed.inches });
      }
    }

    if (includeOrientation) {
      for (i = 0; i < tokens.length; i++) {
        if (used[i]) continue;
        token = tokens[i];
        next = tokens[i + 1] || '';
        phrase = next ? token + ' ' + next : '';
        mapped = ORIENTATION_HINTS[phrase];
        if (mapped) {
          used[i] = true;
          used[i + 1] = true;
          orientations = orientations.concat(mapped);
          continue;
        }
        mapped = ORIENTATION_HINTS[token];
        if (mapped) {
          used[i] = true;
          orientations = orientations.concat(mapped);
        }
      }
    }

    if (heights.length) {
      for (i = 0; i < tokens.length; i++) {
        if (used[i]) continue;
        if (/^(lift|lifts|lifted|leveling|level)$/.test(tokens[i])) used[i] = true;
      }
    }

    return {
      tokens: tokens.filter(function (_token, idx) { return !used[idx]; }),
      heights: heights,
      orientations: uniqueList(orientations)
    };
  }

  function yearSpanFromToken(token) {
    var match = String(token || '').match(/^(\d{4})-(\d{4})$/);
    if (!match) return null;
    var start = parseInt(match[1], 10);
    var end = parseInt(match[2], 10);
    if (!start || !end || end < start || end - start > 40) return null;
    return { start: start, end: end };
  }

  function isSearchYearToken(token) {
    return /^(19|20)\d{2}$/.test(token);
  }

  function tokenDirectMatches(product, hay, token) {
    var span = yearSpanFromToken(token);
    if (span && productOverlapsYearSpan(product, span.start, span.end)) return true;
    if (isSearchYearToken(token) && productFitmentYears(product)[parseInt(token, 10)]) return true;
    if (tokenMatches(hay, token)) return true;
    if (productTypeListMatches(product, token)) return true;
    if (productRideHeightListMatches(product, token)) return true;
    if (productOrientationListMatches(product, token)) return true;
    return productWheelListMatches(product, token);
  }

  function tokenOrFitmentMatches(product, hay, token) {
    if (tokenDirectMatches(product, hay, token)) return true;
    var alts = SEARCH_SYNONYMS[token];
    if (!alts) return false;
    var i;
    for (i = 0; i < alts.length; i++) {
      if (tokenDirectMatches(product, hay, alts[i])) return true;
    }
    return false;
  }

  function skuMatches(product, query) {
    var compact = String(query || '').toLowerCase().replace(/[\s\-]/g, '');
    if (!compact) return false;
    var skus = productSkuList(product);
    var i;
    var skuCompact;
    for (i = 0; i < skus.length; i++) {
      skuCompact = skus[i].replace(/[\s\-]/g, '');
      if (skuCompact === compact) return true;
      if (compact.length >= 4 && skuCompact.indexOf(compact) !== -1) return true;
    }
    return false;
  }

  function catalogIndex(product) {
    var index = product && product._catalogIndex;
    return typeof index === 'number' ? index : 0;
  }

  function fieldTokenScore(field, token) {
    if (!field || !token || !tokenMatches(field, token)) return 0;
    if (field === token) return 100;
    if (field.indexOf(token) === 0) return 90;
    if (field.indexOf(' ' + token) !== -1) return 80;
    return 50;
  }

  function searchMatchScore(product, tokens, raw) {
    var score = 0;
    if (skuMatches(product, raw)) score += 100000;
    var title = String(product.title || '').toLowerCase();
    var vendor = String(product.vendor || '').toLowerCase();
    var type = String(product.type || '').toLowerCase();
    var lists = productTypeList(product).join(' ').toLowerCase();
    var wheels = productWheelList(product).join(' ');
    var kit = productRideHeightList(product).concat(productOrientationList(product)).join(' ');
    var handle = String(product.handle || '').toLowerCase();
    var i;
    var token;
    var best;
    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];
      best = fieldTokenScore(title, token) * 10;
      if (!best) best = fieldTokenScore(wheels, token) * 8;
      if (!best) best = fieldTokenScore(kit, token) * 8;
      if (!best) best = Math.max(fieldTokenScore(vendor, token), fieldTokenScore(type, token)) * 4;
      if (!best) best = fieldTokenScore(lists, token) * 3;
      if (!best) best = fieldTokenScore(handle, token) * 2;
      if (!best) best = 1;
      score += best;
    }
    return score;
  }

  function sortBrowseProducts(list, query) {
    var plan = querySearchPlan(query);
    var tokens = plan.tokens;
    var scored = list.slice();
    if (plan.raw && tokens.length) {
      var scores = {};
      scored.forEach(function (product) {
        scores[product.id] = searchMatchScore(product, tokens, plan.raw);
      });
      scored.sort(function (a, b) {
        var sa = scores[a.id];
        var sb = scores[b.id];
        if (sb !== sa) return sb - sa;
        return catalogIndex(a) - catalogIndex(b);
      });
      return scored;
    }
    scored.sort(function (a, b) {
      return catalogIndex(a) - catalogIndex(b);
    });
    return scored;
  }

  function searchProducts(query, pool) {
    var plan = querySearchPlan(query);
    if (!plan.raw) return [];
    var source = pool || ensureSearchPool();
    var list = plan.vehicle
      ? source.filter(function (product) {
        return matchesVehicleTags(product, plan.vehicle);
      })
      : source;
    var kitMode = isSuspensionKitsCatalog();
    var kitHints = extractKitSearchHints(plan.tokens, kitMode);
    if (kitMode) {
      kitHints.heights = mergeRideHeightHints(kitHints.heights, rideHeightHintsFromQuery(plan.raw));
    } else {
      kitHints.heights = [];
      kitHints.orientations = [];
      kitHints.tokens = plan.tokens.slice();
    }
    var tokens = kitHints.tokens;
    if (kitHints.heights.length) {
      list = list.filter(function (item) {
        return productMatchesRideHeightHints(item, kitHints.heights);
      });
    }
    if (kitHints.orientations.length) {
      list = list.filter(function (item) {
        return productMatchesOrientationHints(item, kitHints.orientations);
      });
    }
    var out = [];
    var seen = {};
    var i;
    var product;

    for (i = 0; i < source.length; i++) {
      product = source[i];
      if (skuMatches(product, plan.raw)) {
        seen[product.id] = true;
        out.push(product);
      }
    }

    if (!tokens.length) {
      if (plan.vehicle || kitHints.heights.length || kitHints.orientations.length) {
        for (i = 0; i < list.length; i++) {
          if (!seen[list[i].id]) out.push(list[i]);
        }
      }
      return out;
    }

    function matchesTokens(item, needed) {
      var haystack = item._q || productSearchText(item);
      var n;
      for (n = 0; n < needed.length; n++) {
        if (!tokenOrFitmentMatches(item, haystack, needed[n])) return false;
      }
      return true;
    }

    var position = tokens.filter(function (token) { return SEARCH_POSITION[token]; });
    var required = tokens.filter(function (token) { return !SEARCH_POSITION[token]; });
    if (!required.length) required = tokens.slice();

    for (i = 0; i < list.length; i++) {
      product = list[i];
      if (seen[product.id]) continue;
      if (matchesTokens(product, tokens)) out.push(product);
    }

    if (!out.length && position.length && required.length < tokens.length) {
      for (i = 0; i < list.length; i++) {
        product = list[i];
        if (seen[product.id]) continue;
        if (matchesTokens(product, required)) out.push(product);
      }
    }
    return out;
  }

  function hasSearchQuery() {
    return String(state.query || '').trim().length > 0;
  }

  function currentBrowseCacheKey() {
    return [
      state.mode,
      state.category || '',
      state.query,
      vehicleKey(),
      state.wheelsInventory ? '1' : '0'
    ].join('|');
  }

  function currentFilteredCacheKey() {
    return [
      currentBrowseCacheKey(),
      selectedVendors().join(','),
      state.subType || '',
      selectedRideHeights().join(','),
      selectedOrientations().join(','),
      WHEEL_FILTERS.map(function (spec) { return state.wheel[spec.key] || ''; }).join('|')
    ].join('::');
  }

  function browseSourceProducts() {
    var key = currentBrowseCacheKey();
    if (browseCacheKeyVal === key && browseCacheList) return browseCacheList;
    var list;
    if (state.mode === 'search') {
      list = hasSearchQuery() ? searchProducts(state.query) : [];
    } else {
      list = categoryProducts();
      if (hasSearchQuery()) list = searchProducts(state.query, list);
    }
    browseCacheKeyVal = key;
    browseCacheList = list;
    return list;
  }

  function filteredProducts() {
    var key = currentFilteredCacheKey();
    if (filteredCacheKeyVal === key && filteredCacheList) return filteredCacheList;
    var list = browseSourceProducts().filter(function (product) {
      return matchesNonWheelFilters(product) && matchesWheelFilters(product);
    });
    list = sortBrowseProducts(list, hasSearchQuery() ? state.query : '');
    filteredCacheKeyVal = key;
    filteredCacheList = list;
    return list;
  }

  function sortedKeys(obj) {
    return Object.keys(obj || {}).sort(function (a, b) {
      var na = Number(a);
      var nb = Number(b);
      if (!isNaN(na) && !isNaN(nb) && String(na) === a && String(nb) === b) return nb - na;
      return a.localeCompare(b);
    });
  }

  function buildYmmIndex(rows) {
    ymmIndex = {};
    ymmByToken = {};
    (Array.isArray(rows) ? rows : []).forEach(function (row) {
      if (!row || !row.ymm) return;
      var make = String(row.make || '').trim();
      var model = String(row.model || '').trim();
      if (!make || !model) return;
      ymmByToken[row.ymm] = row;
      var span = parseYearRange(row);
      if (!span.start) return;
      var year;
      for (year = span.start; year <= span.end; year++) {
        var key = String(year);
        if (!ymmIndex[key]) ymmIndex[key] = {};
        if (!ymmIndex[key][make]) ymmIndex[key][make] = {};
        if (!ymmIndex[key][make][model]) ymmIndex[key][make][model] = [];
        ymmIndex[key][make][model].push(row);
      }
    });
    buildYmmSearchIndex();
  }

  function buildYmmSearchIndex() {
    var makeSeen = {};
    var modelSeen = {};
    var chassisOwners = {};
    ymmMakeNorm = {};
    ymmSearch.makes = [];
    ymmSearch.models = [];
    ymmSearch.aliases = [];
    ymmSearch.modelsByToken = {};
    ymmSearch.aliasesByToken = {};
    ymmRowsAll.forEach(function (row) {
      if (!row) return;
      var make = String(row.make || '').trim();
      var model = String(row.model || '').trim();
      if (make && !makeSeen[make.toLowerCase()]) {
        makeSeen[make.toLowerCase()] = true;
        ymmMakeNorm[make.toLowerCase()] = true;
        ymmSearch.makes.push({
          name: make,
          key: make.toLowerCase(),
          tokens: rawSearchTokens(make)
        });
      }
      if (model && !modelSeen[model.toLowerCase()]) {
        modelSeen[model.toLowerCase()] = true;
        var tokens = rawSearchTokens(model);
        ymmSearch.models.push({
          name: model,
          key: model.toLowerCase(),
          tokens: tokens,
          tokenCount: tokens.length
        });
        var compact = model.toLowerCase().replace(/-/g, '');
        if (compact && compact !== model.toLowerCase() && compact.indexOf(' ') === -1) {
          ymmSearch.models.push({
            name: model,
            key: model.toLowerCase(),
            tokens: [compact],
            tokenCount: 1
          });
        }
        var spaced = model.toLowerCase().replace(/-/g, ' ');
        if (spaced !== model.toLowerCase()) {
          var spacedTokens = rawSearchTokens(spaced);
          if (spacedTokens.length && spacedTokens.join(' ') !== tokens.join(' ')) {
            ymmSearch.models.push({
              name: model,
              key: model.toLowerCase(),
              tokens: spacedTokens,
              tokenCount: spacedTokens.length
            });
          }
        }
      }
      chassisCodesForRow(row).forEach(function (code) {
        if (!chassisOwners[code]) chassisOwners[code] = [];
        chassisOwners[code].push(row);
      });
    });
    ymmSearch.models.sort(function (a, b) {
      if (b.tokenCount !== a.tokenCount) return b.tokenCount - a.tokenCount;
      return b.key.length - a.key.length;
    });

    function addAlias(alias) {
      if (!alias || !alias.phrase) return;
      var tokens = rawSearchTokens(alias.phrase);
      if (!tokens.length) return;
      ymmSearch.aliases.push({
        phrase: alias.phrase,
        make: alias.make || '',
        model: alias.model || '',
        modelContains: alias.modelContains || '',
        yearStart: alias.yearStart || 0,
        yearEnd: alias.yearEnd || 0,
        tokens: tokens,
        tokenCount: tokens.length,
        key: tokens.join(' ')
      });
    }

    MODEL_SEARCH_ALIASES.forEach(addAlias);
    Object.keys(chassisOwners).forEach(function (code) {
      var rows = chassisOwners[code];
      var models = uniqueList(rows.map(function (row) { return row.model; }));
      var makes = uniqueList(rows.map(function (row) { return row.make; }));
      if (models.length !== 1) return;
      var spanStart = 0;
      var spanEnd = 0;
      rows.forEach(function (row) {
        var span = parseYearRange(row);
        if (!span.start) return;
        if (!spanStart || span.start < spanStart) spanStart = span.start;
        if (span.end > spanEnd) spanEnd = span.end;
      });
      addAlias({
        phrase: code,
        make: makes.length === 1 ? makes[0] : '',
        model: models[0],
        yearStart: spanStart,
        yearEnd: spanEnd
      });
    });
    ymmSearch.aliases.sort(function (a, b) {
      if (b.tokenCount !== a.tokenCount) return b.tokenCount - a.tokenCount;
      return b.key.length - a.key.length;
    });

    function indexPhrases(list, bucket) {
      list.forEach(function (entry) {
        var first = entry.tokens && entry.tokens[0];
        if (!first) return;
        if (!bucket[first]) bucket[first] = [];
        bucket[first].push(entry);
      });
    }
    indexPhrases(ymmSearch.models, ymmSearch.modelsByToken);
    indexPhrases(ymmSearch.aliases, ymmSearch.aliasesByToken);
  }

  function findIndexedPhrase(index, tokens, used) {
    var seen = {};
    var best = null;
    var i;
    var list;
    var j;
    var entry;
    var idx;
    for (i = 0; i < tokens.length; i++) {
      if (used[i] || seen[tokens[i]]) continue;
      seen[tokens[i]] = true;
      list = index[tokens[i]];
      if (!list) continue;
      for (j = 0; j < list.length; j++) {
        entry = list[j];
        idx = findTokenPhrase(tokens, used, entry.tokens);
        if (idx === -1) continue;
        if (
          !best ||
          entry.tokenCount > best.entry.tokenCount ||
          (entry.tokenCount === best.entry.tokenCount && entry.key.length > best.entry.key.length)
        ) {
          best = { entry: entry, idx: idx };
        }
      }
    }
    return best;
  }

  function fillSelect(select, placeholder, names) {
    if (!select) return;
    select.innerHTML = '<option value="">' + escapeHtml(placeholder) + '</option>';
    (names || []).forEach(function (name) {
      var option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      select.appendChild(option);
    });
  }

  function readLastVehicle() {
    try {
      var raw = window.localStorage.getItem(LAST_VEHICLE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.year || !data.make || !data.model) return null;
      return {
        year: String(data.year),
        make: String(data.make),
        model: String(data.model)
      };
    } catch (err) {
      return null;
    }
  }

  function writeLastVehicle(vehicle) {
    if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return;
    try {
      window.localStorage.setItem(LAST_VEHICLE_KEY, JSON.stringify({
        year: vehicle.year,
        make: vehicle.make,
        model: vehicle.model
      }));
    } catch (err) {
      /* private mode / quota — fail silent */
    }
  }

  function restoreLastVehicle() {
    var saved = readLastVehicle();
    if (!saved || !yearEl || !ymmIndex[saved.year]) return;
    yearEl.value = saved.year;
    fillMakes();
    if (!makeEl || !ymmIndex[saved.year][saved.make]) return;
    makeEl.value = saved.make;
    fillModels();
    if (!modelEl || !ymmIndex[saved.year][saved.make][saved.model]) return;
    modelEl.value = saved.model;
  }

  function fillYears() {
    fillSelect(yearEl, 'Select Year', sortedKeys(ymmIndex));
    fillMakes();
  }

  function fillMakes() {
    var year = yearEl ? yearEl.value : '';
    var makes = year && ymmIndex[year] ? Object.keys(ymmIndex[year]).sort() : [];
    fillSelect(makeEl, 'Select Make', makes);
    if (makeEl) makeEl.disabled = !makes.length;
    if (makes.length === 1 && makeEl) makeEl.value = makes[0];
    fillModels();
  }

  function fillModels() {
    var year = yearEl ? yearEl.value : '';
    var make = makeEl ? makeEl.value : '';
    var modelsMap = year && make && ymmIndex[year] && ymmIndex[year][make] ? ymmIndex[year][make] : {};
    var names = Object.keys(modelsMap).sort();
    fillSelect(modelEl, 'Select Model', names);
    if (modelEl) modelEl.disabled = !names.length;
    if (names.length === 1 && modelEl) modelEl.value = names[0];
  }

  function getSelectedVehicle() {
    var year = yearEl ? yearEl.value : '';
    var make = makeEl ? makeEl.value : '';
    var model = modelEl ? modelEl.value : '';
    return vehicleFromSelection(year, make, model);
  }

  function setNotice(message, isError) {
    if (!noticeEl) return;
    noticeEl.textContent = message || '';
    noticeEl.classList.toggle('is-error', !!isError && !!message);
  }

  function setScreen(name) {
    state.screen = name;
    root.querySelectorAll('[data-sr-screen]').forEach(function (screen) {
      var active = screen.getAttribute('data-sr-screen') === name;
      screen.classList.toggle('is-active', active);
      screen.hidden = !active;
    });
    if (backEl) {
      backEl.hidden = name === 'ymm';
      if (backLabelEl) {
        backLabelEl.textContent = name === 'products' && state.vehicle && !state.allProducts && !state.wheelsInventory
          ? 'Categories'
          : 'Vehicle';
      }
    }
  }

  function setVehicleLabels() {
    var label = vehicleLabel();
    vehicleEls.forEach(function (el) {
      el.textContent = label;
    });
  }

  function buildCategories() {
    var list = vehicleProducts();
    var buckets = {};

    list.forEach(function (product) {
      productPartTypes(product).forEach(function (category) {
        if (!buckets[category]) {
          buckets[category] = {
            name: category,
            count: 0,
            image: ''
          };
        }
        buckets[category].count += 1;
        if (!buckets[category].image && product.image) {
          buckets[category].image = absUrl(product.image);
        }
      });
    });

    return Object.keys(buckets)
      .sort(function (a, b) {
        var aSort = categorySortIndex(a);
        var bSort = categorySortIndex(b);
        if (aSort !== bSort) return aSort - bSort;
        return a.localeCompare(b);
      })
      .map(function (key) {
        return buckets[key];
      });
  }

  function searchTileHtml() {
    return (
      '<button type="button" class="wf-sr-cat wf-sr-cat--search" data-sr-search-tile>' +
        '<span class="wf-sr-cat__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M16 16l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</span>' +
        '<span class="wf-sr-cat__label">' +
          'Shop By Search' +
          '<span class="wf-sr-cat__meta">Name, brand, year, or type</span>' +
        '</span>' +
      '</button>'
    );
  }

  function renderCategories() {
    setVehicleLabels();
    if (!catsEl) return;
    var list = buildCategories();
    if (catsEmptyEl) catsEmptyEl.hidden = list.length > 0;
    catsEl.innerHTML = searchTileHtml() + list.map(function (bucket) {
      var img = bucket.image
        ? '<img src="' + escapeHtml(bucket.image) + '" alt="">'
        : '';
      var bg = bucket.image ? ' style="background-image:url(\'' + escapeHtml(bucket.image) + '\')"' : '';
      return (
        '<button type="button" class="wf-sr-cat" data-sr-category="' + escapeHtml(bucket.name) + '"' + bg + '>' +
          img +
          '<span class="wf-sr-cat__label">' +
            escapeHtml(bucket.name) +
            '<span class="wf-sr-cat__meta">' + bucket.count + (bucket.count === 1 ? ' item' : ' items') + '</span>' +
          '</span>' +
        '</button>'
      );
    }).join('');
  }

  function renderVendorPills(vendors) {
    if (!vendorPillsEl) return;
    var selected = selectedVendors();
    var ordered = [];
    WHEEL_BRANDS.forEach(function (brand) {
      if (vendors.indexOf(brand.name) !== -1) ordered.push(brand.name);
    });
    vendors.forEach(function (name) {
      if (ordered.indexOf(name) === -1) ordered.push(name);
    });
    vendorPillsEl.innerHTML = ordered.map(function (name) {
      var icon = WHEEL_BRAND_ICONS[name];
      var active = selected.indexOf(name) !== -1;
      var inner = icon
        ? '<img src="' + escapeHtml(icon) + '" alt="">'
        : '<span>' + escapeHtml(name) + '</span>';
      return (
        '<button type="button" class="wf-sr-brand' + (active ? ' is-active' : '') +
        '" data-sr-vendor-pill="' + escapeHtml(name) +
        '" aria-pressed="' + (active ? 'true' : 'false') +
        '" aria-label="' + escapeHtml(name) + '">' +
        inner +
        '</button>'
      );
    }).join('');
  }

  function renderVendorOptions(source) {
    var vendors = uniqueSorted((source || browseSourceProducts()).map(function (product) {
      return product.vendor;
    }));
    state.vendors = selectedVendors().filter(function (name) {
      return vendors.indexOf(name) !== -1;
    });
    var showPills = shouldShowWheelFilters();
    if (vendorPillsEl) vendorPillsEl.hidden = !showPills;
    if (vendorEl) vendorEl.hidden = showPills;
    if (showPills) {
      renderVendorPills(vendors);
      return;
    }
    fillSelect(vendorEl, 'All brands', vendors);
    if (vendorEl) vendorEl.value = state.vendors[0] || '';
  }

  function renderTypePills(source) {
    source = (source || browseSourceProducts()).filter(productMatchesVendors);
    var types = uniqueSorted(source.reduce(function (acc, product) {
      return acc.concat(productSubTypes(product));
    }, []));
    var showTypes = types.length > 0;
    if (state.mode === 'search') {
      showTypes = types.length > 0 && (isPhone() || types.length <= SEARCH_TYPE_PILL_MAX);
    }
    if (typeFilterEl) typeFilterEl.hidden = !showTypes;
    if (!showTypes) {
      if (state.mode === 'search') state.subType = '';
      if (typesEl) typesEl.innerHTML = '';
      fillSelect(typeSelectEl, 'All', []);
      return;
    }
    if (state.subType && types.indexOf(state.subType) === -1) state.subType = '';
    fillSelect(typeSelectEl, 'All', types);
    if (typeSelectEl) typeSelectEl.value = state.subType || '';
    if (!typesEl) return;
    var html = '<button type="button" class="wf-sr-pill' + (!state.subType ? ' is-active' : '') + '" data-sr-type="">All</button>';
    html += types.map(function (type) {
      return (
        '<button type="button" class="wf-sr-pill' + (state.subType === type ? ' is-active' : '') + '" data-sr-type="' +
        escapeHtml(type) + '">' + escapeHtml(type) + '</button>'
      );
    }).join('');
    typesEl.innerHTML = html;
  }

  function renderKitPills(el, values, selected, attr) {
    if (!el) return;
    el.innerHTML = values.map(function (value) {
      var active = selected.indexOf(value) !== -1;
      return (
        '<button type="button" class="wf-sr-pill' + (active ? ' is-active' : '') +
        '" ' + attr + '="' + escapeHtml(value) +
        '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
        escapeHtml(value) + '</button>'
      );
    }).join('');
  }

  function productsForKitOptions(exceptKey, source) {
    return (source || browseSourceProducts()).filter(function (product) {
      return matchesNonWheelFilters(product, exceptKey) && matchesWheelFilters(product);
    });
  }

  function shouldShowSuspensionFilters() {
    if (!isSuspensionKitsCatalog()) return false;
    if (state.mode === 'search' && !hasSearchQuery()) return false;
    return true;
  }

  function hideKitFilters() {
    if (kitFiltersEl) kitFiltersEl.hidden = true;
    if (rideHeightFilterEl) rideHeightFilterEl.hidden = true;
    if (orientationFilterEl) orientationFilterEl.hidden = true;
  }

  function renderKitFilters(source) {
    if (!shouldShowSuspensionFilters()) {
      if (hasSuspensionFilter()) clearSuspensionFilters();
      hideKitFilters();
      return;
    }
    var pool = source || browseSourceProducts();
    var heights = sortRideHeightValues(
      productsForKitOptions('rideHeights', pool).reduce(function (acc, product) {
        return acc.concat(productRideHeights(product));
      }, [])
    );
    var orients = sortOrientationValues(
      productsForKitOptions('orientations', pool).map(productOrientation).filter(Boolean)
    );
    state.rideHeights = selectedRideHeights().filter(function (value) {
      return heights.indexOf(value) !== -1;
    });
    state.orientations = selectedOrientations().filter(function (value) {
      return orients.indexOf(value) !== -1;
    });
    if (rideHeightFilterEl) rideHeightFilterEl.hidden = heights.length === 0;
    if (orientationFilterEl) orientationFilterEl.hidden = orients.length === 0;
    if (kitFiltersEl) kitFiltersEl.hidden = heights.length === 0 && orients.length === 0;
    renderKitPills(rideHeightsEl, heights, selectedRideHeights(), 'data-sr-ride-height');
    renderKitPills(orientationsEl, orients, selectedOrientations(), 'data-sr-orientation');
  }

  function uniqueSortedWheel(values, key) {
    var list = uniqueSorted(values);
    if (key !== 'diameter') return list;
    return list.sort(function (a, b) {
      var na = parseFloat(String(a).match(/\d+(?:\.\d+)?/));
      var nb = parseFloat(String(b).match(/\d+(?:\.\d+)?/));
      if (!isNaN(na) && !isNaN(nb) && na !== nb) return na - nb;
      return a.localeCompare(b);
    });
  }

  function productsForWheelOptions(exceptKey, source) {
    return (source || browseSourceProducts()).filter(function (product) {
      return matchesNonWheelFilters(product) && matchesWheelFilters(product, exceptKey);
    });
  }

  function tokenLooksLikeWheelSpec(token) {
    if (!token) return false;
    if (WHEEL_QUERY_WORDS[token]) return true;
    if (/^(1[5-9]|2[0-4])(?:"|in|inch|inches)?$/.test(token)) return true;
    if (/^\d+x\d+(?:\.\d+)?$/.test(token)) return true;
    var compact = compactWheelText(token);
    return !!(compact && wheelSearchIndex[compact]);
  }

  function queryLooksLikeWheels(query) {
    var tokens = rawSearchTokens(query);
    var i;
    for (i = 0; i < tokens.length; i++) {
      if (tokenLooksLikeWheelSpec(tokens[i])) return true;
    }
    return false;
  }

  function searchHitsAreWheelOnly() {
    var hits = browseSourceProducts();
    var i;
    var sawWheel = false;
    if (!hits.length) return false;
    for (i = 0; i < hits.length; i++) {
      if (isWheelProduct(hits[i])) {
        sawWheel = true;
      } else if (isCatalogProduct(hits[i])) {
        return false;
      }
    }
    return sawWheel;
  }

  function shouldShowWheelFilters() {
    if (state.wheelsInventory && state.mode === 'category') return true;
    if (state.mode === 'category') return isWheelCategory(state.category);
    if (state.mode !== 'search' || !hasSearchQuery()) return false;
    return queryLooksLikeWheels(state.query) || searchHitsAreWheelOnly();
  }

  function syncWheelBlock(key, value) {
    var wrap = wheelFiltersEl ? wheelFiltersEl.querySelector('[data-sr-wheel-filter="' + key + '"]') : null;
    if (!wrap) return;
    var valueEl = wrap.querySelector('[data-sr-wheel-value]');
    if (valueEl) valueEl.textContent = value || 'All';
    wrap.classList.toggle('is-set', !!value);
  }

  function selectValuesMatch(select, names) {
    var list = names || [];
    if (!select || select.options.length !== list.length + 1) return false;
    var i;
    for (i = 0; i < list.length; i++) {
      if (select.options[i + 1].value !== list[i]) return false;
    }
    return true;
  }

  function renderWheelFilters(source) {
    var show = shouldShowWheelFilters();
    if (wheelFiltersEl) wheelFiltersEl.hidden = !show;
    if (!show) {
      if (hasWheelFilter()) clearWheelFilters();
      return;
    }
    var pool = source || browseSourceProducts();
    syncingWheelFilters = true;
    WHEEL_FILTERS.forEach(function (spec) {
      var wrap = wheelFiltersEl ? wheelFiltersEl.querySelector('[data-sr-wheel-filter="' + spec.key + '"]') : null;
      var select = wheelFiltersEl ? wheelFiltersEl.querySelector('[data-sr-wheel="' + spec.key + '"]') : null;
      var values = uniqueSortedWheel(
        productsForWheelOptions(spec.key, pool).map(function (product) {
          return productWheelValue(product, spec.field);
        }),
        spec.key
      );
      if (wrap) wrap.hidden = values.length === 0;
      if (!values.length) {
        state.wheel[spec.key] = '';
        fillSelect(select, spec.all, []);
        syncWheelBlock(spec.key, '');
        return;
      }
      if (state.wheel[spec.key] && values.indexOf(state.wheel[spec.key]) === -1) {
        state.wheel[spec.key] = '';
      }
      if (!selectValuesMatch(select, values)) fillSelect(select, spec.all, values);
      if (select) select.value = state.wheel[spec.key] || '';
      syncWheelBlock(spec.key, state.wheel[spec.key]);
    });
    syncingWheelFilters = false;
  }

  function searchIdleImages() {
    var seen = {};
    var out = [];
    function add(image, name) {
      var src = absUrl(image);
      if (!src || seen[src] || out.length >= 8) return;
      seen[src] = true;
      out.push({ image: src, name: name || '' });
    }
    buildCategories().forEach(function (bucket) {
      add(bucket.image, bucket.name);
    });
    if (out.length < 4) {
      vehicleProducts().forEach(function (product) {
        add(product.image, productPartTypes(product)[0] || '');
      });
    }
    return out;
  }

  function renderSearchIdle() {
    if (!searchIdleTilesEl) return;
    var key = vehicleKey();
    if (searchIdleKey === key && searchIdleTilesEl.childNodes.length) return;
    searchIdleTilesEl.innerHTML = searchIdleImages().map(function (tile) {
      return (
        '<div class="wf-sr-search-idle__tile">' +
          '<img src="' + escapeHtml(tile.image) + '" alt="" draggable="false">' +
          (tile.name ? '<span>' + escapeHtml(tile.name) + '</span>' : '') +
        '</div>'
      );
    }).join('');
    searchIdleKey = key;
  }

  function setSearchIdle(on) {
    if (browseEl) browseEl.classList.toggle('is-search-idle', !!on);
    if (searchIdleEl) searchIdleEl.hidden = !on;
    if (on) renderSearchIdle();
  }

  function activeFilterCount() {
    var count = selectedVendors().length;
    if (state.subType) count += 1;
    count += selectedRideHeights().length;
    count += selectedOrientations().length;
    WHEEL_FILTERS.forEach(function (spec) {
      if (state.wheel[spec.key]) count += 1;
    });
    return count;
  }

  function syncPhoneFiltersToggle() {
    var show = isPhone() && railFiltersEl && !railFiltersEl.hidden;
    if (filtersToggleEl) {
      filtersToggleEl.hidden = !show;
      var count = activeFilterCount();
      if (filtersToggleLabelEl) {
        filtersToggleLabelEl.textContent = count ? ('Filters · ' + count) : 'Filters';
      }
      filtersToggleEl.setAttribute('aria-expanded', phoneFiltersOpen ? 'true' : 'false');
      filtersToggleEl.classList.toggle('is-open', phoneFiltersOpen);
    }
    if (railFiltersEl) {
      railFiltersEl.classList.toggle('is-collapsed', !!(show && !phoneFiltersOpen));
    }
  }

  function syncBrowseMode() {
    var isSearch = state.mode === 'search';
    if (browseEl) browseEl.classList.toggle('is-search', isSearch);
    if (railSearchEl) railSearchEl.hidden = false;
    if (railFiltersEl) railFiltersEl.hidden = isSearch && !hasSearchQuery();
    if (searchEl) {
      searchEl.placeholder = isSearch
        ? 'Name, brand, size, or SKU'
        : (state.wheelsInventory ? 'Search wheels' : 'Search this category');
    }
    syncPhoneFiltersToggle();
  }

  function renderProductCards(list) {
    return list.map(function (product) {
      var src = absUrl(product.image);
      var mediaStyle = src ? ' style="background-image:url(\'' + escapeHtml(src) + '\')"' : '';
      var img = src
        ? '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(product.title) + '">'
        : '<span class="wf-sr-card__ph" aria-hidden="true"></span>';
      return (
        '<button type="button" class="wf-sr-card" data-sr-details="' + escapeHtml(String(product.id)) + '">' +
          '<span class="wf-sr-card__inner">' +
            '<span class="wf-sr-card__media"' + mediaStyle + '>' + img + '</span>' +
            '<span class="wf-sr-card__copy">' +
              '<span class="wf-sr-card__title"><span class="wf-sr-card__title-text">' + escapeHtml(product.title) + '</span></span>' +
              '<span class="wf-sr-card__price">' + formatPrice(product) + '</span>' +
            '</span>' +
          '</span>' +
        '</button>'
      );
    }).join('');
  }

  function cardElement(product) {
    var id = String(product.id);
    if (cardEls[id]) return cardEls[id];
    var wrap = document.createElement('div');
    wrap.innerHTML = renderProductCards([product]);
    cardEls[id] = wrap.firstChild;
    return cardEls[id];
  }

  function syncProductGrid(shown, append) {
    if (!gridEl) return;
    if (append) {
      var already = gridEl.querySelectorAll('[data-sr-details]').length;
      if (already < shown.length) {
        shown.slice(already).forEach(function (product) {
          gridEl.appendChild(cardElement(product));
        });
      }
      lastGridIds = shown.map(function (product) { return String(product.id); }).join(',');
      return;
    }
    var nextIds = shown.map(function (product) { return String(product.id); }).join(',');
    if (nextIds === lastGridIds && gridEl.childElementCount === shown.length) return;
    var missing = 0;
    shown.forEach(function (product) {
      if (!cardEls[String(product.id)]) missing += 1;
    });
    if (!gridEl.childElementCount && missing === shown.length) {
      gridEl.innerHTML = renderProductCards(shown);
      Array.prototype.forEach.call(gridEl.querySelectorAll('[data-sr-details]'), function (el) {
        cardEls[el.getAttribute('data-sr-details')] = el;
      });
      lastGridIds = nextIds;
      return;
    }
    lastGridIds = nextIds;
    var keep = {};
    shown.forEach(function (product) {
      keep[String(product.id)] = true;
      gridEl.appendChild(cardElement(product));
    });
    Array.prototype.slice.call(gridEl.children).forEach(function (el) {
      if (!keep[el.getAttribute('data-sr-details')]) gridEl.removeChild(el);
    });
  }

  function scheduleFilterChrome() {
    if (filterTimer) window.clearTimeout(filterTimer);
    filterTimer = window.setTimeout(function () {
      filterTimer = 0;
      if (state.screen !== 'products') return;
      if (state.mode === 'search' && !hasSearchQuery()) return;
      renderVendorOptions();
      renderTypePills();
      renderKitFilters();
      renderWheelFilters();
      syncPhoneFiltersToggle();
    }, 80);
  }

  function resetGridPage() {
    state.visibleCount = GRID_PAGE_SIZE;
  }

  function setLoadMoreVisible(visible) {
    if (moreEl) moreEl.hidden = !visible;
  }

  function renderProducts(opts) {
    var append = !!(opts && opts.append);
    var fromSearch = !!(opts && opts.fromSearch);
    var isSearch = state.mode === 'search';
    if (hasSearchQuery() && queryUsesParsedVehicle()) {
      state.queryVehicle = querySearchPlan(state.query).vehicle;
    } else {
      state.queryVehicle = null;
    }
    syncBrowseMode();
    if (railTitleEl) {
      railTitleEl.textContent = isSearch
        ? 'Search'
        : (state.wheelsInventory ? 'Wheels' : (state.category || ''));
    }
    setVehicleLabels();

    if (!gridEl) return;
    if (isSearch && !hasSearchQuery()) {
      clearVendorFilters();
      state.subType = '';
      clearSuspensionFilters();
      clearWheelFilters();
      state.visibleCount = GRID_PAGE_SIZE;
      gridEl.innerHTML = '';
      lastGridIds = '';
      if (countEl) countEl.textContent = '';
      if (emptyEl) emptyEl.hidden = true;
      setLoadMoreVisible(false);
      setSearchIdle(true);
      if (typeFilterEl) typeFilterEl.hidden = true;
      if (wheelFiltersEl) wheelFiltersEl.hidden = true;
      if (vendorPillsEl) vendorPillsEl.hidden = true;
      hideKitFilters();
      syncPhoneFiltersToggle();
      return;
    }

    setSearchIdle(false);

    var list = filteredProducts();
    var limit = state.visibleCount || GRID_PAGE_SIZE;
    if (limit < GRID_PAGE_SIZE) limit = GRID_PAGE_SIZE;
    state.visibleCount = limit;
    var shown = list.slice(0, limit);

    if (countEl) {
      countEl.textContent = shown.length < list.length
        ? 'Showing ' + shown.length + ' of ' + list.length + ' products'
        : list.length + (list.length === 1 ? ' product' : ' products');
    }

    if (!list.length) {
      gridEl.innerHTML = '';
      lastGridIds = '';
      setLoadMoreVisible(false);
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.textContent = hasSearchQuery()
          ? 'No products match this search.'
          : 'No products match these filters.';
      }
      if (fromSearch) scheduleFilterChrome();
      else {
        renderVendorOptions(browseSourceProducts());
        renderTypePills(browseSourceProducts());
        renderKitFilters(browseSourceProducts());
        renderWheelFilters(browseSourceProducts());
        syncPhoneFiltersToggle();
      }
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    syncProductGrid(shown, append && gridEl.children.length);
    setLoadMoreVisible(shown.length < list.length);
    if (fromSearch) {
      scheduleFilterChrome();
    } else {
      renderVendorOptions(browseSourceProducts());
      renderTypePills(browseSourceProducts());
      renderKitFilters(browseSourceProducts());
      renderWheelFilters(browseSourceProducts());
      syncPhoneFiltersToggle();
    }
  }

  function findProductById(id) {
    var target = String(id || '');
    if (!target) return null;
    var lists = [activeCatalog()];
    if (products && products !== lists[0]) lists.push(products);
    if (wheelsProducts && wheelsProducts !== products && wheelsProducts !== lists[0]) {
      lists.push(wheelsProducts);
    }
    var i;
    var j;
    var list;
    for (i = 0; i < lists.length; i++) {
      list = lists[i] || [];
      for (j = 0; j < list.length; j++) {
        if (String(list[j].id) === target) return list[j];
      }
    }
    return null;
  }

  function productImages(product) {
    var images = Array.isArray(product.images) ? product.images.filter(Boolean).map(absUrl) : [];
    if (!images.length && product.image) images = [absUrl(product.image)];
    return images;
  }

  function formatPrice(product, variant) {
    var price = variant && variant.price ? variant.price : product.price || '';
    var compare = variant && variant.compareAt ? variant.compareAt : product.compareAt || '';
    var priceCents = variant && variant.priceCents != null ? variant.priceCents : product.priceCents;
    var compareCents = variant && variant.compareAtCents != null ? variant.compareAtCents : product.compareAtCents;
    if (compare && compareCents && priceCents && compareCents > priceCents) {
      return escapeHtml(price) + ' <s>' + escapeHtml(compare) + '</s>';
    }
    return escapeHtml(price);
  }

  function formatShortDescription(text) {
    var raw = String(text || '').trim();
    if (!raw) return '';
    if (/<[a-z][\s\S]*>/i.test(raw)) return raw;
    return '<p>' + escapeHtml(raw).replace(/\r\n|\r|\n/g, '<br>') + '</p>';
  }

  function formatProductDescription(html) {
    var raw = String(html || '').trim();
    if (!raw) return '';
    if (!/<[a-z][\s\S]*>/i.test(raw)) return formatShortDescription(raw);
    var box = document.createElement('div');
    box.innerHTML = raw;
    Array.prototype.forEach.call(box.querySelectorAll('script, style, iframe, object, embed'), function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    return box.innerHTML.trim();
  }

  function lightboxExtraTab() {
    return lightboxTabsEl ? lightboxTabsEl.querySelector('[data-sr-lightbox-tab="fitment"]') : null;
  }

  function setLightboxExtraMode(isWheel) {
    var extra = lightboxExtraTab();
    if (extra) extra.textContent = isWheel ? 'Specs' : 'Fitment';
    if (lightboxFitmentEl) lightboxFitmentEl.classList.toggle('is-specs', !!isWheel);
  }

  function setLightboxTab(tab) {
    var next = tab === 'fitment' ? 'fitment' : 'details';
    state.lightboxTab = next;
    if (lightboxTabsEl) {
      lightboxTabsEl.querySelectorAll('[data-sr-lightbox-tab]').forEach(function (button) {
        var active = button.getAttribute('data-sr-lightbox-tab') === next;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    if (lightboxDescEl) lightboxDescEl.hidden = next !== 'details';
    if (lightboxFitmentEl) lightboxFitmentEl.hidden = next !== 'fitment';
    if (lightboxScrollEl) lightboxScrollEl.scrollTop = 0;
  }

  function setLightboxDetails(html, asHtml) {
    if (!lightboxDescEl) return;
    var cleaned = asHtml ? formatProductDescription(html) : formatShortDescription(html);
    lightboxDescEl.innerHTML = cleaned || '<p>No details available for this product.</p>';
  }

  function renderLightboxSpecs(product) {
    if (!lightboxFitmentEl) return;
    lightboxFitmentEl.innerHTML = (
      '<div class="wf-sr-lightbox__specs">' +
      WHEEL_FILTERS.map(function (spec) {
        var value = productWheelValue(product, spec.field);
        return (
          '<div class="wf-sr-lightbox__spec' + (value ? ' is-set' : '') + '">' +
            '<span class="wf-sr-lightbox__spec-label">' + escapeHtml(spec.label) + '</span>' +
            '<span class="wf-sr-lightbox__spec-value">' + escapeHtml(value || '—') + '</span>' +
          '</div>'
        );
      }).join('') +
      '</div>'
    );
    if (lightboxTabsEl) lightboxTabsEl.hidden = false;
  }

  function applyLightboxPanels(product) {
    var isWheel = isWheelProduct(product);
    setLightboxExtraMode(isWheel);
    if (isWheel) {
      setLightboxDetails(product.description || '', true);
      renderLightboxSpecs(product);
      return;
    }
    setLightboxDetails(product.shortDescription || '', false);
    setLightboxFitment(product.table || '');
  }

  function sanitizeFitmentHtml(rootEl) {
    if (!rootEl) return;
    var tables = rootEl.querySelectorAll('#cm-fitment-table, .cm_fitment-table, .product-fitment-table-content');
    Array.prototype.forEach.call(tables, function (table) {
      if (table.id === 'cm-fitment-table') {
        table.removeAttribute('id');
        table.classList.add('product-fitment-table-content');
      }
      Array.prototype.forEach.call(
        table.querySelectorAll('[class*="cmTemplate"], [class*="cmRepeater"]'),
        function (el) {
          Array.prototype.slice.call(el.classList).forEach(function (cls) {
            if (cls.indexOf('cmTemplate') === 0 || cls.indexOf('cmRepeater') === 0) {
              el.classList.remove(cls);
            }
          });
        }
      );
      Array.prototype.forEach.call(
        table.querySelectorAll('.collapsed, [style*="height"], [style*="overflow"], [style*="max-height"]'),
        function (el) {
          el.classList.remove('collapsed');
          el.removeAttribute('style');
        }
      );
    });
    Array.prototype.forEach.call(rootEl.querySelectorAll('.cm_fitment-table__horizontal, .fitment-table-container'), function (horizontal) {
      var bodies = horizontal.querySelectorAll('.fitment-table-fitment');
      if (bodies.length < 2) return;
      var primary = bodies[0];
      var i;
      for (i = 1; i < bodies.length; i++) {
        var extra = bodies[i];
        while (extra.firstChild) primary.appendChild(extra.firstChild);
        if (extra.parentNode) extra.parentNode.removeChild(extra);
      }
      primary.classList.remove('collapsed');
      primary.removeAttribute('style');
    });
    Array.prototype.forEach.call(
      rootEl.querySelectorAll('.cm_collapsible-elem, [class*="initiallyHidden"], .fitment-table-fitment, .fitment-table-body'),
      function (el) {
        el.classList.remove('collapsed');
        if (el.hasAttribute('style')) el.removeAttribute('style');
        if (el.getAttribute('aria-hidden') === 'true') el.removeAttribute('aria-hidden');
      }
    );
  }

  function revealAllFitmentRows(tableWrapper) {
    if (!tableWrapper) return;
    tableWrapper.setAttribute('data-fitment-initialized', 'true');
    Array.prototype.forEach.call(
      tableWrapper.querySelectorAll('.fitment-row.fitment-row--hidden'),
      function (row) { row.classList.remove('fitment-row--hidden'); }
    );
    Array.prototype.forEach.call(
      tableWrapper.querySelectorAll('.fitment-view-more-wrapper'),
      function (el) { if (el.parentNode) el.parentNode.removeChild(el); }
    );
  }

  function expandLcFitments(rootEl) {
    if (!rootEl) return;
    Array.prototype.forEach.call(rootEl.querySelectorAll('.lc-fitments'), function (widget) {
      widget.classList.remove('collapsed');
      widget.classList.add('expanded');
      widget.classList.add('is-sr-open');
      Array.prototype.forEach.call(widget.querySelectorAll('details'), function (details) {
        details.open = true;
      });
      Array.prototype.forEach.call(
        widget.querySelectorAll('.controls, .fade, script'),
        function (el) { if (el.parentNode) el.parentNode.removeChild(el); }
      );
    });
  }

  function setLightboxFitment(html) {
    if (!lightboxFitmentEl) return;
    var raw = String(html || '').trim();
    if (!raw) {
      lightboxFitmentEl.innerHTML = '';
      if (lightboxTabsEl) lightboxTabsEl.hidden = true;
      setLightboxTab('details');
      return;
    }
    lightboxFitmentEl.innerHTML = '<div class="product-fitment-table">' + raw + '</div>';
    sanitizeFitmentHtml(lightboxFitmentEl);
    expandLcFitments(lightboxFitmentEl);
    Array.prototype.forEach.call(
      lightboxFitmentEl.querySelectorAll('.product-fitment-table'),
      revealAllFitmentRows
    );
    if (lightboxTabsEl) lightboxTabsEl.hidden = false;
  }

  function renderLightboxThumbs(product) {
    if (!lightboxThumbsEl) return;
    var images = productImages(product);
    if (images.length > 1) {
      lightboxThumbsEl.hidden = false;
      lightboxThumbsEl.innerHTML = images.map(function (src, index) {
        return (
          '<button type="button" class="' + (index === 0 ? 'is-active' : '') + '" data-sr-thumb="' + escapeHtml(src) + '">' +
            '<img src="' + escapeHtml(src) + '" alt="">' +
          '</button>'
        );
      }).join('');
    } else {
      lightboxThumbsEl.innerHTML = '';
      lightboxThumbsEl.hidden = true;
    }
  }

  function parseJsonResponse(res) {
    if (!res.ok) throw new Error('product');
    return res.text().then(function (text) {
      return JSON.parse(text);
    });
  }

  function fetchProductDetail(product) {
    var handle = product && product.handle ? product.handle : '';
    if (!handle) return Promise.reject(new Error('handle'));
    return fetch('/products/' + encodeURIComponent(handle) + '?view=showroom-json', { credentials: 'same-origin' })
      .then(parseJsonResponse);
  }

  function applyProductDetail(product, detail) {
    if (!detail) return;
    product.shortDescription = detail.shortDescription || '';
    product.description = detail.description || '';
    product.table = detail.table || '';
    product.detailLoaded = true;
    if (Array.isArray(detail.images) && detail.images.length) {
      product.images = detail.images;
    }
    applyLightboxPanels(product);
  }

  function setLightboxImage(src, alt) {
    if (!lightboxImageEl) return;
    if (src) {
      lightboxImageEl.src = src;
      lightboxImageEl.alt = alt || '';
      lightboxImageEl.style.display = '';
    } else {
      lightboxImageEl.removeAttribute('src');
      lightboxImageEl.alt = '';
      lightboxImageEl.style.display = 'none';
    }
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    if (Date.now() < lightboxIgnoreCloseUntil) return;
    lightboxEl.classList.remove('is-open');
    lightboxEl.hidden = true;
    if (lightboxLastFocus && typeof lightboxLastFocus.focus === 'function') {
      lightboxLastFocus.focus();
    }
    lightboxLastFocus = null;
  }

  function openLightbox(productId) {
    var product = findProductById(productId);
    if (!product || !lightboxEl) return;
    state.lightboxProductId = product.id;
    lightboxLastFocus = document.activeElement;
    lightboxIgnoreCloseUntil = Date.now() + 400;

    var images = [];
    var variants = [];
    var isWheel = false;
    try {
      images = productImages(product);
      setLightboxImage(images[0] || absUrl(product.image), product.title);
      renderLightboxThumbs(product);

      if (lightboxVendorEl) lightboxVendorEl.textContent = product.vendor || 'Product details';
      if (lightboxTitleEl) lightboxTitleEl.textContent = product.title || '';
      if (lightboxPriceEl) lightboxPriceEl.innerHTML = formatPrice(product);
      if (lightboxScrollEl) lightboxScrollEl.scrollTop = 0;

      variants = Array.isArray(product.variants) ? product.variants.filter(function (variant) {
        return variant && variant.available;
      }) : [];
      if (lightboxVariantEl && lightboxVariantWrap) {
        if (variants.length > 1) {
          lightboxVariantWrap.hidden = false;
          lightboxVariantEl.hidden = false;
          lightboxVariantEl.innerHTML = variants.map(function (variant) {
            return '<option value="' + escapeHtml(String(variant.id)) + '">' + escapeHtml(variant.title) + ' — ' + escapeHtml(variant.price) + '</option>';
          }).join('');
          lightboxVariantEl.value = String(product.variantId || variants[0].id);
        } else {
          lightboxVariantWrap.hidden = true;
          lightboxVariantEl.hidden = true;
          lightboxVariantEl.innerHTML = '';
        }
      }

      isWheel = isWheelProduct(product);
      setLightboxExtraMode(isWheel);
      if (lightboxTabsEl) lightboxTabsEl.hidden = !isWheel;
      setLightboxTab('details');
      if (isWheel) renderLightboxSpecs(product);
      if (product.detailLoaded) {
        applyLightboxPanels(product);
      } else if (product.handle) {
        setLightboxDetails('Loading details…');
        if (!isWheel && lightboxFitmentEl) lightboxFitmentEl.innerHTML = '';
        fetchProductDetail(product)
          .then(function (detail) {
            if (String(state.lightboxProductId) !== String(product.id)) return;
            applyProductDetail(product, detail);
            if (detail && Array.isArray(detail.images) && detail.images.length) {
              if (!images.length) setLightboxImage(absUrl(detail.images[0]), product.title);
              renderLightboxThumbs(product);
            }
          })
          .catch(function () {
            if (String(state.lightboxProductId) !== String(product.id)) return;
            if (isWheel) {
              setLightboxDetails('');
              renderLightboxSpecs(product);
            } else {
              setLightboxDetails('');
              setLightboxFitment('');
            }
          });
      } else if (isWheel) {
        setLightboxDetails('');
        renderLightboxSpecs(product);
      } else {
        setLightboxDetails('');
        setLightboxFitment('');
      }

      if (lightboxAtcEl) {
        var variantId = product.variantId || (variants[0] && variants[0].id) || '';
        lightboxAtcEl.setAttribute('data-sr-atc', String(variantId));
        lightboxAtcEl.disabled = !variantId;
        lightboxAtcEl.textContent = 'Add to cart';
        lightboxAtcEl.classList.remove('is-added');
      }
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[showroom] lightbox', err);
      }
    }

    lightboxEl.hidden = false;
    lightboxEl.classList.add('is-open');
    var closeBtn = lightboxEl.querySelector('.wf-sr-lightbox__close');
    if (closeBtn) {
      try { closeBtn.focus(); } catch (focusErr) { /* ignore */ }
    }
  }

  function currentLightboxVariantId() {
    if (lightboxVariantEl && !lightboxVariantEl.hidden && lightboxVariantEl.value) {
      return lightboxVariantEl.value;
    }
    return lightboxAtcEl ? lightboxAtcEl.getAttribute('data-sr-atc') : '';
  }

  function hostCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function openHostCart(addResponse) {
    closeLightbox();
    var hostCart = hostCartElement();
    if (hostCart && addResponse && addResponse.sections && typeof hostCart.renderContents === 'function') {
      try {
        hostCart.renderContents(addResponse);
        return true;
      } catch (err) {
        /* fall through */
      }
    }
    var icon = document.querySelector('#cart-icon-bubble');
    if (icon) {
      icon.click();
      return true;
    }
    window.location.assign('/cart');
    return true;
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function (cart) {
        var count = cart && cart.item_count ? Number(cart.item_count) : 0;
        if (!cartCountEl) return;
        cartCountEl.textContent = String(count);
        cartCountEl.hidden = count < 1;
      })
      .catch(function () {
        /* badge is optional */
      });
  }

  function addToCart(variantId, btn) {
    if (!variantId || !btn || btn.disabled) return;
    var original = btn.textContent;
    var hostCart = hostCartElement();
    var body = {
      id: Number(variantId),
      quantity: 1
    };
    if (hostCart && typeof hostCart.getSectionsToRender === 'function') {
      body.sections = hostCart.getSectionsToRender().map(function (section) {
        return section.id;
      }).join(',');
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function (data) {
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        openHostCart(data);
        refreshCartCount();
        window.setTimeout(refreshCartCount, 400);
        window.setTimeout(function () {
          btn.textContent = original || 'Add to cart';
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
        window.setTimeout(function () {
          btn.textContent = original || 'Add to cart';
        }, 1600);
      });
  }

  function dedupeProducts() {
    var seen = {};
    products = products.filter(function (product) {
      var id = String(product.id);
      if (seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function setLoadMessage(message) {
    if (!loadEl) return;
    if (!message) {
      loadEl.hidden = true;
      loadEl.textContent = '';
      return;
    }
    loadEl.hidden = false;
    loadEl.textContent = message;
  }

  function setContinueEnabled(enabled) {
    if (continueEl) {
      continueEl.disabled = !enabled;
      continueEl.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      continueEl.setAttribute('aria-busy', enabled ? 'false' : 'true');
    }
    if (searchAllEl) {
      searchAllEl.disabled = !enabled;
      searchAllEl.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
  }

  function setWheelsButtonEnabled(enabled) {
    if (wheelsInventoryEl) {
      wheelsInventoryEl.disabled = !enabled;
      wheelsInventoryEl.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
  }

  function attachWheelsInventoryFromMain() {
    wheelsProducts = products;
    wheelsInventoryReady = catalogReady;
    wheelsInventoryError = !catalogReady;
    setWheelsButtonEnabled(wheelsInventoryReady);
  }

  function loadCatalog() {
    var pageSize = config.pageSize || CATALOG_PAGE_SIZE;
    var handle = config.collectionHandle || '';
    var knownCount = Number(config.productsCount) || 0;
    var startedAt = (window.performance && performance.now) ? performance.now() : Date.now();
    var pagesRequested = 0;
    var pagesLoaded = 0;
    var pagesFailed = 0;

    setContinueEnabled(false);

    if (!handle) {
      catalogReady = false;
      catalogError = true;
      setLoadMessage('Assign a catalog collection on this page to load inventory.');
      return Promise.resolve();
    }

    setLoadMessage('Loading products… 0%');

    function nowMs() {
      return (window.performance && performance.now) ? performance.now() : Date.now();
    }

    function ingest(batch, page) {
      if (!batch.length) return 0;
      var before = products.length;
      var base = ((page || 1) - 1) * pageSize;
      var i;
      for (i = 0; i < batch.length; i++) {
        if (batch[i]) batch[i]._catalogIndex = base + i;
      }
      products = products.concat(batch);
      dedupeProducts();
      if (state.screen === 'categories') renderCategories();
      if (state.screen === 'products') renderProducts();
      return products.length - before;
    }

    function progressMessage() {
      var total = pagesRequested || (knownCount > 0 ? Math.max(1, Math.ceil(knownCount / pageSize)) : 0);
      var pct = total ? Math.min(100, Math.round((pagesLoaded / total) * 100)) : 0;
      return 'Loading products… ' + pct + '%';
    }

    function fetchPage(page) {
      pagesRequested += 1;
      var url = '/collections/' + encodeURIComponent(handle) + '?view=showroom-json&page=' + page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Showroom catalog request failed');
          return res.text();
        })
        .then(function (text) {
          var batch = [];
          try {
            batch = JSON.parse(text);
          } catch (err) {
            throw new Error('Showroom catalog JSON invalid');
          }
          if (!Array.isArray(batch)) batch = [];
          pagesLoaded += 1;
          var added = ingest(batch, page);
          setLoadMessage(progressMessage());
          return { page: page, batch: batch, failed: false, added: added };
        })
        .catch(function () {
          pagesFailed += 1;
          return { page: page, batch: [], failed: true };
        });
    }

    function fetchRange(fromPage, toPage) {
      var jobs = [];
      var p;
      for (p = fromPage; p <= toPage; p += 1) {
        jobs.push(fetchPage(p));
      }
      return Promise.all(jobs);
    }

    function finish() {
      products.sort(function (a, b) {
        return catalogIndex(a) - catalogIndex(b);
      });
      catalogReady = products.length > 0;
      catalogError = products.length === 0;
      setContinueEnabled(catalogReady);
      var ms = Math.round(nowMs() - startedAt);
      if (typeof console !== 'undefined' && console.info) {
        console.info(
          '[showroom] catalog loaded',
          products.length + ' products in ' + ms + 'ms',
          '(' + pagesLoaded + '/' + pagesRequested + ' pages' +
            (pagesFailed ? ', ' + pagesFailed + ' failed' : '') + ')',
          handle,
          config.collectionSource || 'none'
        );
      }
      rebuildWheelSearchIndex();
      if (catalogHandlesMatch()) attachWheelsInventoryFromMain();
      scheduleCatalogWarm(products);
      if (catalogReady) {
        setLoadMessage('');
      } else {
        setLoadMessage('Unable to load inventory. Refresh and try again.');
      }
      if (state.screen === 'categories') renderCategories();
      if (state.screen === 'products') renderProducts();
    }

    var firstCount = knownCount > 0 ? Math.max(1, Math.ceil(knownCount / pageSize)) : 12;

    function loadFrom(startPage, count) {
      return fetchRange(startPage, startPage + count - 1).then(function (results) {
        var last = results[results.length - 1];
        var lastFull = last && !last.failed && last.batch.length >= pageSize;
        var lastAdded = last && last.added > 0;
        var anyOk = results.some(function (result) { return !result.failed; });
        var lastPage = startPage + count - 1;
        // Shopify paginate past the last real page often re-sends a full 250-item
        // page (duplicates). "last page is full" is not "there is more catalog."
        if (lastFull && lastAdded && lastPage < MAX_CATALOG_PAGES) {
          return loadFrom(startPage + count, 2);
        }
        if (!anyOk && startPage === 1) throw new Error('Showroom catalog request failed');
      });
    }

    return loadFrom(1, firstCount)
      .then(finish)
      .catch(function () {
        catalogReady = products.length > 0;
        catalogError = products.length === 0;
        setContinueEnabled(catalogReady);
        rebuildWheelSearchIndex();
        if (catalogHandlesMatch()) attachWheelsInventoryFromMain();
        setLoadMessage(catalogReady ? '' : 'Unable to load inventory. Refresh and try again.');
      });
  }

  function fetchShowroomCollection(handle) {
    var pageSize = config.pageSize || CATALOG_PAGE_SIZE;
    var list = [];
    var seen = {};

    function ingest(batch, page) {
      if (!batch.length) return 0;
      var added = 0;
      var base = ((page || 1) - 1) * pageSize;
      var i;
      var product;
      var id;
      for (i = 0; i < batch.length; i++) {
        product = batch[i];
        if (!product) continue;
        product._catalogIndex = base + i;
        id = String(product.id);
        if (seen[id]) continue;
        seen[id] = true;
        list.push(product);
        added += 1;
      }
      return added;
    }

    function fetchPage(page) {
      var url = '/collections/' + encodeURIComponent(handle) + '?view=showroom-json&page=' + page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Showroom catalog request failed');
          return res.text();
        })
        .then(function (text) {
          var batch = [];
          try {
            batch = JSON.parse(text);
          } catch (err) {
            throw new Error('Showroom catalog JSON invalid');
          }
          if (!Array.isArray(batch)) batch = [];
          return { page: page, batch: batch, failed: false, added: ingest(batch, page) };
        })
        .catch(function () {
          return { page: page, batch: [], failed: true, added: 0 };
        });
    }

    function fetchRange(fromPage, toPage) {
      var jobs = [];
      var p;
      for (p = fromPage; p <= toPage; p += 1) {
        jobs.push(fetchPage(p));
      }
      return Promise.all(jobs);
    }

    function loadFrom(startPage, count) {
      return fetchRange(startPage, startPage + count - 1).then(function (results) {
        var last = results[results.length - 1];
        var lastFull = last && !last.failed && last.batch.length >= pageSize;
        var lastAdded = last && last.added > 0;
        var anyOk = results.some(function (result) { return !result.failed; });
        var lastPage = startPage + count - 1;
        if (lastFull && lastAdded && lastPage < MAX_CATALOG_PAGES) {
          return loadFrom(startPage + count, 2);
        }
        if (!anyOk && startPage === 1) throw new Error('Showroom catalog request failed');
      });
    }

    return loadFrom(1, 12).then(function () {
      list.sort(function (a, b) {
        return catalogIndex(a) - catalogIndex(b);
      });
      return list;
    });
  }

  function loadWheelsInventory() {
    if (catalogHandlesMatch()) return;
    setWheelsButtonEnabled(false);
    fetchShowroomCollection(WHEELS_INVENTORY_HANDLE)
      .then(function (list) {
        wheelsProducts = list;
        wheelsInventoryReady = list.length > 0;
        wheelsInventoryError = !wheelsInventoryReady;
        setWheelsButtonEnabled(wheelsInventoryReady);
        rebuildWheelSearchIndex();
        scheduleCatalogWarm(list);
        if (typeof console !== 'undefined' && console.info) {
          console.info('[showroom] wheel inventory loaded', list.length + ' products', WHEELS_INVENTORY_HANDLE);
        }
        if (state.wheelsInventory && state.screen === 'products') renderProducts();
      })
      .catch(function () {
        wheelsInventoryReady = wheelsProducts.length > 0;
        wheelsInventoryError = !wheelsInventoryReady;
        setWheelsButtonEnabled(wheelsInventoryReady);
      });
  }

  function resetBrowseState() {
    state.category = null;
    state.mode = 'category';
    state.query = '';
    clearVendorFilters();
    state.subType = '';
    clearSuspensionFilters();
    clearWheelFilters();
    state.queryVehicle = null;
    resetGridPage();
    clearSearchCaches();
    lastGridIds = '';
    if (searchEl) searchEl.value = '';
    phoneFiltersOpen = false;
    setSearchIdle(false);
  }

  function goToYmm() {
    state.vehicle = null;
    state.allProducts = false;
    state.wheelsInventory = false;
    resetBrowseState();
    searchPool = [];
    searchPoolKey = '';
    searchIdleKey = '';
    setSearchIdle(false);
    setScreen('ymm');
    setNotice('', false);
  }

  function goToCategories() {
    if (!catalogReady) {
      setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
      return;
    }
    resetBrowseState();
    renderCategories();
    setScreen('categories');
    setNotice('', false);
  }

  function goToProducts(category) {
    state.mode = 'category';
    state.category = category;
    state.query = '';
    clearVendorFilters();
    state.subType = '';
    clearSuspensionFilters();
    clearWheelFilters();
    resetGridPage();
    clearSearchCaches();
    lastGridIds = '';
    if (searchEl) searchEl.value = '';
    phoneFiltersOpen = false;
    renderProducts();
    setScreen('products');
  }

  function goToSearch() {
    state.mode = 'search';
    state.category = null;
    state.query = '';
    clearVendorFilters();
    state.subType = '';
    clearSuspensionFilters();
    clearWheelFilters();
    resetGridPage();
    if (searchEl) searchEl.value = '';
    phoneFiltersOpen = false;
    ensureSearchPool();
    renderProducts();
    setScreen('products');
    window.setTimeout(function () {
      if (searchEl) searchEl.focus();
    }, 40);
  }

  function goToSearchAll() {
    if (!catalogReady) {
      setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
      return;
    }
    state.vehicle = null;
    state.allProducts = true;
    state.wheelsInventory = false;
    resetBrowseState();
    searchPool = [];
    searchPoolKey = '';
    searchIdleKey = '';
    goToSearch();
    setNotice('', false);
  }

  function goToWheelsInventory() {
    if (!wheelsInventoryReady) {
      setNotice(
        wheelsInventoryError ? 'Unable to load wheel inventory. Refresh and try again.' : 'Loading wheels…',
        wheelsInventoryError
      );
      return;
    }
    state.vehicle = null;
    state.allProducts = true;
    state.wheelsInventory = true;
    resetBrowseState();
    state.mode = 'category';
    state.category = 'Wheels';
    searchPool = [];
    searchPoolKey = '';
    searchIdleKey = '';
    prepareCatalogSearch(wheelsProducts);
    renderProducts();
    setScreen('products');
    setNotice('', false);
  }

  function applySearchQuery(value) {
    state.query = String(value || '');
    resetGridPage();
    if (searchEl && searchEl.value !== state.query) searchEl.value = state.query;
    if (searchRaf) window.cancelAnimationFrame(searchRaf);
    searchRaf = window.requestAnimationFrame(function () {
      searchRaf = 0;
      renderProducts({ fromSearch: true });
    });
  }

  buildYmmIndex(ymmRowsAll);
  fillYears();
  restoreLastVehicle();
  refreshCartCount();
  loadCatalog();
  loadWheelsInventory();

  if (yearEl) {
    yearEl.addEventListener('change', function () {
      fillMakes();
      setNotice('', false);
    });
  }
  if (makeEl) {
    makeEl.addEventListener('change', function () {
      fillModels();
      setNotice('', false);
    });
  }
  if (modelEl) {
    modelEl.addEventListener('change', function () {
      setNotice('', false);
    });
  }

  if (formEl) {
    formEl.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!catalogReady) {
        setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
        return;
      }
      var vehicle = getSelectedVehicle();
      if (!vehicle) {
        setNotice('Please complete Year, Make, and Model.', true);
        return;
      }
      writeLastVehicle(vehicle);
      state.vehicle = vehicle;
      state.allProducts = false;
      state.wheelsInventory = false;
      resetBrowseState();
      goToCategories();
    });
  }

  if (searchAllEl) {
    searchAllEl.addEventListener('click', function () {
      goToSearchAll();
    });
  }

  if (wheelsInventoryEl) {
    wheelsInventoryEl.addEventListener('click', function () {
      goToWheelsInventory();
    });
  }

  if (backEl) {
    backEl.addEventListener('click', function () {
      closeLightbox();
      if (state.screen === 'products') {
        if (state.allProducts || !state.vehicle) {
          goToYmm();
          return;
        }
        goToCategories();
        return;
      }
      goToYmm();
    });
  }

  if (cartEl) {
    cartEl.addEventListener('click', function (event) {
      if (openHostCart()) event.preventDefault();
    });
  }

  if (catsEl) {
    catsEl.addEventListener('click', function (event) {
      if (event.target.closest('[data-sr-search-tile]')) {
        goToSearch();
        return;
      }
      var button = event.target.closest('[data-sr-category]');
      if (!button) return;
      goToProducts(button.getAttribute('data-sr-category'));
    });
  }

  if (searchFormEl) {
    searchFormEl.addEventListener('submit', function (event) {
      event.preventDefault();
      if (searchEl) applySearchQuery(searchEl.value);
    });
  }

  if (searchEl) {
    searchEl.addEventListener('input', function () {
      applySearchQuery(searchEl.value);
    });
  }

  if (vendorEl) {
    vendorEl.addEventListener('change', function () {
      state.vendors = vendorEl.value ? [vendorEl.value] : [];
      resetGridPage();
      renderProducts();
    });
  }

  if (vendorPillsEl) {
    vendorPillsEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sr-vendor-pill]');
      if (!button) return;
      var name = button.getAttribute('data-sr-vendor-pill') || '';
      if (!name) return;
      var next = selectedVendors().slice();
      var index = next.indexOf(name);
      if (index === -1) next.push(name);
      else next.splice(index, 1);
      state.vendors = next;
      resetGridPage();
      renderProducts();
    });
  }

  if (typesEl) {
    typesEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sr-type]');
      if (!button) return;
      state.subType = button.getAttribute('data-sr-type') || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (typeSelectEl) {
    typeSelectEl.addEventListener('change', function () {
      state.subType = typeSelectEl.value || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (rideHeightsEl) {
    rideHeightsEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sr-ride-height]');
      if (!button) return;
      var value = button.getAttribute('data-sr-ride-height') || '';
      if (!value) return;
      state.rideHeights = toggleSelectedValue(selectedRideHeights(), value);
      resetGridPage();
      renderProducts();
    });
  }

  if (orientationsEl) {
    orientationsEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sr-orientation]');
      if (!button) return;
      var value = button.getAttribute('data-sr-orientation') || '';
      if (!value) return;
      state.orientations = toggleSelectedValue(selectedOrientations(), value);
      resetGridPage();
      renderProducts();
    });
  }

  if (filtersToggleEl) {
    filtersToggleEl.addEventListener('click', function () {
      phoneFiltersOpen = !phoneFiltersOpen;
      syncPhoneFiltersToggle();
    });
  }

  if (wheelFiltersEl) {
    wheelFiltersEl.addEventListener('change', function (event) {
      if (syncingWheelFilters) return;
      var select = event.target.closest('[data-sr-wheel]');
      if (!select) return;
      var key = select.getAttribute('data-sr-wheel');
      if (!key || !Object.prototype.hasOwnProperty.call(state.wheel, key)) return;
      state.wheel[key] = select.value || '';
      syncWheelBlock(key, state.wheel[key]);
      resetGridPage();
      renderProducts();
    });
  }

  if (loadMoreEl) {
    loadMoreEl.addEventListener('click', function () {
      state.visibleCount = (state.visibleCount || GRID_PAGE_SIZE) + GRID_LOAD_MORE;
      renderProducts({ append: true });
    });
  }

  if (gridEl) {
    gridEl.addEventListener('click', function (event) {
      var node = event.target;
      if (node && node.nodeType !== 1) node = node.parentElement;
      var trigger = node && node.closest ? node.closest('[data-sr-details]') : null;
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      openLightbox(trigger.getAttribute('data-sr-details'));
    });
  }

  if (lightboxTabsEl) {
    lightboxTabsEl.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-sr-lightbox-tab]');
      if (!tab) return;
      setLightboxTab(tab.getAttribute('data-sr-lightbox-tab'));
    });
  }

  if (lightboxEl) {
    lightboxEl.addEventListener('click', function (event) {
      if (event.target.closest('[data-sr-lightbox-close]')) {
        closeLightbox();
        return;
      }
      var thumb = event.target.closest('[data-sr-thumb]');
      if (thumb) {
        setLightboxImage(thumb.getAttribute('data-sr-thumb'), lightboxTitleEl ? lightboxTitleEl.textContent : '');
        lightboxEl.querySelectorAll('[data-sr-thumb]').forEach(function (btn) {
          btn.classList.toggle('is-active', btn === thumb);
        });
      }
    });
  }

  if (lightboxVariantEl) {
    lightboxVariantEl.addEventListener('change', function () {
      if (lightboxAtcEl) lightboxAtcEl.setAttribute('data-sr-atc', lightboxVariantEl.value);
      var product = findProductById(state.lightboxProductId);
      if (!product) return;
      var variant = (product.variants || []).filter(function (item) {
        return String(item.id) === String(lightboxVariantEl.value);
      })[0];
      if (lightboxPriceEl) lightboxPriceEl.innerHTML = formatPrice(product, variant);
      if (variant && variant.image) setLightboxImage(absUrl(variant.image), product.title);
    });
  }

  if (lightboxAtcEl) {
    lightboxAtcEl.addEventListener('click', function () {
      addToCart(currentLightboxVariantId(), lightboxAtcEl);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });

  if (window.matchMedia) {
    var phoneMq = window.matchMedia('(max-width: 820px)');
    var onPhoneMq = function () {
      if (!isPhone()) phoneFiltersOpen = false;
      if (state.screen === 'products') renderProducts();
      else syncPhoneFiltersToggle();
    };
    if (phoneMq.addEventListener) phoneMq.addEventListener('change', onPhoneMq);
    else if (phoneMq.addListener) phoneMq.addListener(onPhoneMq);
  }
})();
